export const apiInvoicesV3Controller = {
  updateAllInvoicesFilteredToInvoiceDto: { path: '/api/v3/invoices/' },
  updateInvoiceToItemsDto: { path: '/api/v3/invoices/INVOICE_ITEM_DTO' },
  createInvoiceAsInvoiceItem: { path: '/api/v3/invoices/INVOICE_ITEM_DTO' },
  getInvoicesSummaryExportDto: { path: '/api/v3/invoices/summary-data/EXPORT' },
  getPagedInvoiceItemsDto: { path: '/api/v3/invoices/paged' },
  getInvoiceIdsDto: { path: '/api/v3/invoices/list/IDS' },
  createInvoiceViaInbox: { path: '/api/v3/invoices/inbox' },
  getInvoiceItemDto: { path: '/api/v3/invoices/${invoiceId}' },
  getSuggestionsByInvoiceId: { path: '/api/v3/invoices/${invoiceId}/suggestions' },
  getSuggestionsByInvoiceIdWithText: { path: '/api/v3/invoices/${invoiceId}/suggestionsWithText' },
  getLastReviewActionLog: { path: '/api/v3/invoices/${invoiceId}/lastReviewAction' },
  getInvoiceActivities: { path: '/api/v3/invoices/${invoiceId}/activities' },
  deleteInvoices: { path: '/api/v3/invoices' },
}
export const apiSupplierAccountV2Controller = {
  markComplianceValidationExempt: {
    path: '/api/v2/supplier-account/${supplierAccountId}/mark-compliance-validation-exempt',
  },
  addMissingBicToSupplierAccount: {
    path: '/api/v2/supplier-account/update-missing-bic/${supplierAccountId}',
  },
  removeSupplierEmployeeMappingBySupplierAccountId: {
    path: '/api/v2/supplier-account/remove-employee-mapping/supplierAccountId/${supplierAccountId}',
  },
  removeSupplierEmployeeMappingByOrganisationAndEmployeeId: {
    path: '/api/v2/supplier-account/remove-employee-mapping/employeeId/${organisationId}/${employeeId}',
  },
  createSupplierAccount: { path: '/api/v2/supplier-account' },
  getById: { path: '/api/v2/supplier-account/${supplierAccountId}' },
  updateSupplierAccount: { path: '/api/v2/supplier-account/${supplierAccountId}' },
  deleteSupplierAccount: { path: '/api/v2/supplier-account/${supplierAccountId}' },
  updateSupplierAndRecipient: {
    path: '/api/v2/supplier-account/${supplierAccountId}/update-supplier-and-recipient',
  },
  pullAttributesFromSourceOrganisation: { path: '/api/v2/supplier-account/pull-from-other-org' },
  createSupplierAndRecipient: { path: '/api/v2/supplier-account/create-supplier-and-recipient' },
  bulkUpdateSuppliers: { path: '/api/v2/supplier-account/bulk-update' },
  bulkTriggerSuppliersSync: { path: '/api/v2/supplier-account/bulk-sync' },
  bulkDeleteInvoices: { path: '/api/v2/supplier-account/bulk-delete' },
  batchUploadSuppliers: { path: '/api/v2/supplier-account/batch-upload' },
  batchUploadReviewSuppliers: { path: '/api/v2/supplier-account/batch-upload/review' },
  updateSupplierAccounting: { path: '/api/v2/supplier-account/accounting/${supplierAccountId}' },
  updateEmployee: { path: '/api/v2/supplier-account/${supplierAccountId}/employee' },
  getSupplierAndRecipientBySupplierId: {
    path: '/api/v2/supplier-account/${supplierAccountId}/supplier-and-recipient',
  },
  getSupplierAccountActivityLog: {
    path: '/api/v2/supplier-account/${supplierAccountId}/change-log',
  },
  getSupplierAccountsSlim: { path: '/api/v2/supplier-account/slim' },
  getAllByOrganisation: { path: '/api/v2/supplier-account/organisation' },
  getAllPagedByOrganisation: { path: '/api/v2/supplier-account/organisation/paged' },
  getSuppliersIdsByOrganisationWithoutPagination: {
    path: '/api/v2/supplier-account/organisation/all/ids',
  },
  getByEmployeeId: { path: '/api/v2/supplier-account/employee/${employeeId}' },
}
export const apiSpendPolicyControllerV2 = {
  updateOrCreateDraft: { path: '/api/v2/spend-policy/draft' },
  switchTov2: { path: '/api/v2/spend-policy/switch-to-v2' },
  generateFromV1: { path: '/api/v2/spend-policy/generate-from-v1' },
  publishDraftPolicy: { path: '/api/v2/spend-policy/draft/publish' },
  deleteDraftPolicy: { path: '/api/v2/spend-policy/draft/delete' },
  getPolicies: { path: '/api/v2/spend-policy' },
  getPolicyById: { path: '/api/v2/spend-policy/policies/${id}' },
  isPostSpendApprovalEffectivelyEnabled: {
    path: '/api/v2/spend-policy/is-psa-effectively-enabled',
  },
}
export const apiWorkflowSettingController = {
  getAllByOrg: { path: '/api/v1/workflow/settings' },
  upsert: { path: '/api/v1/workflow/settings' },
  getByCodeAndOrg: { path: '/api/v1/workflow/settings/code/${settingCode}' },
}
export const apiTransactionVatController = {
  getVatById: { path: '/api/v1/vat/${vatId}' },
  updateVat: { path: '/api/v1/vat/${vatId}' },
  deleteVat: { path: '/api/v1/vat/${vatId}' },
  bulkUpdateVats: { path: '/api/v1/vat/bulk-update' },
  getAllForOrganisation: { path: '/api/v1/vat' },
  createVat: { path: '/api/v1/vat' },
  getVatsPaged: { path: '/api/v1/vat/paged' },
  initDefaultVatForOrganisation: { path: '/api/v1/vat/init' },
  getVatByIds: { path: '/api/v1/vat/${vatIds}' },
  getTemplates: { path: '/api/v1/vat/templates' },
  getVatListForOrganisation: { path: '/api/v1/vat/list' },
}
export const apiUserController = {
  updateUserPhone: { path: '/api/v1/users/${userId}/phone' },
  confirmPhone: { path: '/api/v1/users/${userId}/phone/confirm' },
  updateOrgStructure: { path: '/api/v1/users/${userId}/org-structure' },
  updateOrgStructureBatch: { path: '/api/v1/users/org-structure/batch' },
  updateOrgStructureBatchByIds: { path: '/api/v1/users/org-structure/batch-by-ids' },
  updateOrgStructureBatchByFilter: { path: '/api/v1/users/org-structure/batch-by-filter' },
  requestOtp: { path: '/api/v1/users/${userId}/request-otp' },
  requestPhoneConfirmation: { path: '/api/v1/users/${userId}/phone/request-confirmation' },
  getUserProfilesSlim: { path: '/api/v1/user-profile/slim' },
}
export const apiCardsController = {
  updateCardStatus: { path: '/api/v1/user/${userId}/card/${cardId}' },
  activateVirtualCardForUser: { path: '/api/v1/user/${userId}/card/virtual/${cardId}/active' },
  saveCardAccountingAttributes: { path: '/api/v1/cards/accounting-attributes' },
  getCard: { path: '/api/v1/card/${cardId}' },
  updateCardStatusDeprecated: { path: '/api/v1/card/${cardId}' },
  activateVirtualCard: { path: '/api/v1/card/virtual/${cardId}/active' },
  createBulkCards: { path: '/api/v1/users/bulk-cards' },
  createCard: { path: '/api/v1/user/${userId}/card' },
  getTeamCardsPaged: { path: '/api/v1/team/cards/paged' },
  getOrganisationCardsPagedPost: { path: '/api/v1/organisation/cards' },
  getByCardId: { path: '/api/v1/cards/${cardId}/notifications/spend-limit' },
  updateSpendNotificationsSettings: { path: '/api/v1/cards/${cardId}/notifications/spend-limit' },
  confirmThreeDsTxAuthentication: { path: '/api/v1/cards/transactions/authentication/confirm' },
  uploadSubscriptionMigrationFile: { path: '/api/v1/cards/subscription/migration-file' },
  getUserCardsPaginated: { path: '/api/v1/cards/paged' },
  downloadCsv: { path: '/api/v1/cards/download/csv' },
  reissueVirtualCard: { path: '/api/v1/card/virtual/${cardId}/reissue' },
  reorderPhysicalCard: { path: '/api/v1/card/reorder' },
  saveShippingAddressForPhysicalCardReorder: {
    path: '/api/v1/card/physical/reorder/shipping-address',
  },
  activatePhysicalCard: { path: '/api/v1/card/physical/active' },
  verifyLastFourDigitsForPhysicalCard: {
    path: '/api/v1/card/physical/active/verify-last-four-digits',
  },
  activateReplacedPhysicalCard: { path: '/api/v1/card/physical/active/replacement' },
  getSubscriptionFileUploaded: { path: '/api/v1/cards/subscription/migration-file/uploaded' },
  getCardsSlim: { path: '/api/v1/cards/slim' },
  getAllowedCardTypes: { path: '/api/v1/cards/allowed-card-types' },
  getAllowedCardTypesByTypesForUser: {
    path: '/api/v1/cards/allowed-card-types/${requestedCardType}/users/${userId}',
  },
  findCardChangeLogsByCardId: { path: '/api/v1/card/${cardId}/card-change-log' },
  getVirtualPanPreviewToken: { path: '/api/v1/card/virtual/${cardId}/details-token' },
  getVirtualPanPreviewWithCategoryToken: {
    path: '/api/v1/card/virtual/${cardId}/details-token/${riskCategory}',
  },
  getPhysicalCardOneTimeToken: { path: '/api/v1/card/physical/one-time-token' },
}
export const apiUserProfileController = {
  get: { path: '/api/v1/user-profile' },
  update: { path: '/api/v1/user-profile' },
  getByUserId: { path: '/api/v1/user-profile/${userId}' },
  updateUser: { path: '/api/v1/user-profile/${userId}' },
  language: { path: '/api/v1/user-profile/language' },
  uploadProfilePicture: { path: '/api/v1/user-profile/profile-picture' },
  deleteProfilePicture: { path: '/api/v1/user-profile/profile-picture' },
  getUserProfilesPaged: { path: '/api/v1/user-profile/paged' },
  confirmEmail: { path: '/api/v1/user-profile/email-confirmation' },
  getEmailConfirmationEmail: { path: '/api/v1/user-profile/email-confirmation/${userId}' },
  getEmailConfirmationEmailWithEmail: {
    path: '/api/v1/user-profile/email-confirmation-with-email/${email}',
  },
}
export const apiAddressController = {
  getPersonalAddress: { path: '/api/v1/user-profile/address' },
  updatePersonalAddress: { path: '/api/v1/user-profile/address' },
  createPersonalAddress: { path: '/api/v1/user-profile/address' },
  updateOrganisationShippingAddress: { path: '/api/v1/organisation/shipping-address' },
  createOrganisationShippingAddress: { path: '/api/v1/organisation/shipping-address' },
  updateOrganisationAddress: { path: '/api/v1/organisation/address' },
  createOrganisationAddress: { path: '/api/v1/organisation/address' },
  deleteAddressForUser: { path: '/api/v1/user/addresses/${addressType}' },
}
export const apiUserOrganisationSystemSettingsController = {
  getUserOrganisationSystemSettings: {
    path: '/api/v1/user-organisation-system-settings/${organisationId}/user/${userId}',
  },
  updateUserOrganisationSystemSettings: {
    path: '/api/v1/user-organisation-system-settings/${organisationId}/user/${userId}',
  },
}
export const apiSubTransactionController = {
  getSubTransactions: { path: '/api/v1/transactions/${flowId}/sub-transactions' },
  upsertSubTransactions: { path: '/api/v1/transactions/${flowId}/sub-transactions' },
  create: { path: '/api/v1/transactions/${flowId}/sub-transactions' },
  deleteAllSubTransactions: { path: '/api/v1/transactions/${flowId}/sub-transactions' },
  updateSubTransaction: { path: '/api/v1/transactions/${flowId}/sub-transactions/${id}' },
}
export const apiTeamsController = {
  getById: { path: '/api/v1/teams/${teamId}' },
  updateTeam: { path: '/api/v1/teams/${teamId}' },
  deleteTeam: { path: '/api/v1/teams/${teamId}' },
  updateTeamMembers: { path: '/api/v1/teams/${teamId}/team-members' },
  getByOrganisationId: { path: '/api/v1/teams' },
  createTeam: { path: '/api/v1/teams' },
  updateTeams: { path: '/api/v1/teams/bulk_update' },
  getByIds: { path: '/api/v1/teams/${teamIds}' },
  getByTeamLeadId: { path: '/api/v1/teams/team-lead' },
  deleteTeamLeadFromTeam: { path: '/api/v1/teams/${teamId}/team-lead' },
}
export const apiSupplierAccountController = {
  addMissingBicToSupplierAccount: {
    path: '/api/v1/supplier-account/update-missing-bic/${supplierAccountId}',
  },
  removeSupplierEmployeeMappingBySupplierAccountId: {
    path: '/api/v1/supplier-account/remove-employee-mapping/supplierAccountId/${supplierAccountId}',
  },
  removeSupplierEmployeeMappingByOrganisationAndEmployeeId: {
    path: '/api/v1/supplier-account/remove-employee-mapping/employeeId/${organisationId}/${employeeId}',
  },
  createSupplierAccount: { path: '/api/v1/supplier-account' },
  getById: { path: '/api/v1/supplier-account/${supplierAccountId}' },
  updateSupplierAccount: { path: '/api/v1/supplier-account/${supplierAccountId}' },
  deleteSupplierAccount: { path: '/api/v1/supplier-account/${supplierAccountId}' },
  bulkUpdateSuppliers: { path: '/api/v1/supplier-account/bulk-update' },
  bulkDeleteInvoices: { path: '/api/v1/supplier-account/bulk-delete' },
  batchUploadSuppliers: { path: '/api/v1/supplier-account/batch-upload' },
  batchUploadReviewSuppliers: { path: '/api/v1/supplier-account/batch-upload/review' },
  updateSupplierAccounting: { path: '/api/v1/supplier-account/accounting/${supplierAccountId}' },
  getByIds: { path: '/api/v1/supplier-account/${supplierAccountIds}' },
  getAllByOrganisation: { path: '/api/v1/supplier-account/organisation' },
  getAllPagedByOrganisation: { path: '/api/v1/supplier-account/organisation/paged' },
  getSuppliersIdsByOrganisationWithoutPagination: {
    path: '/api/v1/supplier-account/organisation/all/ids',
  },
  getByEmployeeId: { path: '/api/v1/supplier-account/employee/${employeeId}' },
}
export const apiSubCategoryController = {
  getSubcategoryById: { path: '/api/v1/sub-category/${subCategoryId}' },
  updateSubCategory: { path: '/api/v1/sub-category/${subCategoryId}' },
  deleteSubCategory: { path: '/api/v1/sub-category/${subCategoryId}' },
  createSubCategory: { path: '/api/v1/sub-category' },
  pullAttributesFromSourceOrganisation: { path: '/api/v1/sub-category/pull-from-other-org' },
  bulkUpdateSubCategories: { path: '/api/v1/sub-category/bulk-update' },
  batchUpload: { path: '/api/v1/sub-category/batch-upload' },
  batchUploadReview: { path: '/api/v1/sub-category/batch-upload/review' },
  getSubcategoryByIds: { path: '/api/v1/sub-category/${subCategoryIds}' },
  getAllPagedByOrganisation: { path: '/api/v1/sub-category/paged' },
  getSubcategoryForOrganisation: { path: '/api/v1/sub-category/list' },
  getGroupedSubcategoryForOrganisation: { path: '/api/v1/sub-category/list/grouped' },
}
export const apiSpendRequestController = {
  requestUpdateCard: { path: '/api/v1/spend-request/card' },
  requestCreateCard: { path: '/api/v1/spend-request/card' },
  uploadCardAttachment: { path: '/api/v1/spend-request/cards/attachment' },
  getCardAttachmentThumbnail: { path: '/api/v1/spend-request/cards/attachment/${id}/thumbnail' },
  downloadCardAttachment: { path: '/api/v1/spend-request/cards/attachment/${id}/download' },
  deleteAttachment: { path: '/api/v1/spend-request/cards/attachment/${id}' },
}
export const apiReimbursementLineController = {
  updateLine: { path: '/api/v1/reimbursement/${reimbursementId}/line' },
  createLine: { path: '/api/v1/reimbursement/${reimbursementId}/line' },
}
export const apiUserAddressesController = {
  createOrUpdateAddressForUser: { path: '/api/v1/reimbursement/user/addresses/${addressType}' },
}
export const apiAccountingSettingsController = {
  createOrUpdateAccountingSettings: {
    path: '/api/v1/reimbursement/organisation/accounting-settings/${lineType}',
  },
  findAllAccountingSettings: { path: '/api/v1/reimbursement/organisation/accounting-settings' },
}
export const apiReimbursementController = {
  moveBackStatusChange: { path: '/api/v1/reimbursement/move-back-status-change' },
  uploadMileageFile: { path: '/api/v1/reimbursement/${reimbursementId}/mileage/attachment' },
  fetchReimbursementSummaryData: { path: '/api/v1/reimbursement/summary-data' },
  previewSepaPaymentFile: { path: '/api/v1/reimbursement/sepa-file/preview' },
  exportSepaPaymentFile: { path: '/api/v1/reimbursement/sepa-file/export' },
  handleRequest: { path: '/api/v1/reimbursement/request' },
  handleRequestV2: { path: '/api/v1/reimbursement/request/v2' },
  calculatePerDiem: { path: '/api/v1/reimbursement/perdiem' },
  fetchPaginatedReimbursements: { path: '/api/v1/reimbursement/paged' },
  calculateMileageV2: { path: '/api/v1/reimbursement/mileage' },
  calculateMileageV3: { path: '/api/v1/reimbursement/mileage/v3' },
  export: { path: '/api/v1/reimbursement/export' },
  getExportStatusUpdateCompletionStatusForReimbursements: {
    path: '/api/v1/reimbursement/export-status-update-completion/status/ids',
  },
  uploadExpenseFile: { path: '/api/v1/reimbursement/expense/${expenseId}/attachment' },
  downloadFile: { path: '/api/v1/reimbursement/download' },
  handleCustomisationRequest: { path: '/api/v1/reimbursement/customisation/request' },
  downloadCsv: { path: '/api/v1/reimbursement/csv' },
  downloadCustomCsv: { path: '/api/v1/reimbursement/csv/templates/${templateId}' },
  fetchReimbursementsIdsWithoutPagination: { path: '/api/v1/reimbursement/all/ids' },
  findActivityByReimbursementId: { path: '/api/v1/reimbursement/${reimbursementId}/activity/V2' },
  findById: { path: '/api/v1/reimbursement/${id}' },
  getCustomisationSettings: { path: '/api/v1/reimbursement/customisation/settings' },
  deleteMileageFile: {
    path: '/api/v1/reimbursement/${reimbursementId}/mileage/attachment/${fileId}',
  },
  deleteExpenseFile: { path: '/api/v1/reimbursement/expense/${expenseId}/attachment/${fileId}' },
}
export const apiPurchaseRequestsController = {
  updatePurchaseRequests: { path: '/api/v1/purchase-requests' },
  deletePurchaseRequests: { path: '/api/v1/purchase-requests' },
  updateAllPurchaseRequests: { path: '/api/v1/purchase-requests/all' },
  getPurchaseRequestsSummary: { path: '/api/v1/purchase-requests/summary' },
  getLinkedSpendsToPr: { path: '/api/v1/purchase-requests/spendsLinked' },
  getPagedPurchaseRequests: { path: '/api/v1/purchase-requests/paged' },
  getReferenceLinkedItems: { path: '/api/v1/purchase-requests/linkedItems' },
  download: { path: '/api/v1/purchase-requests/download/${templateId}' },
  getPurchaseRequestLinkedToSpend: {
    path: '/api/v1/purchase-requests/${spendId}/purchaseRequestLinked',
  },
  getPurchaseRequestDto: { path: '/api/v1/purchase-requests/${purchaseRequestId}' },
  getSuggestionsByPrId: { path: '/api/v1/purchase-requests/${purchaseRequestId}/suggestions' },
  getSuggestionsByIdTextAndType: {
    path: '/api/v1/purchase-requests/${purchaseRequestId}/suggestionsWithText',
  },
  getActivityLogs: { path: '/api/v1/purchase-requests/${purchaseRequestId}/activity' },
}
export const apiPurchaseRequestCreationController = {
  createPurchaseRequestWithFile: { path: '/api/v1/purchase-requests' },
}
export const prospectController = {
  pricingPlanSelected: { path: '/api/v1/prospects/pricing-plan' },
  updateOrganisationDetails: { path: '/api/v1/prospects/organisation-details' },
  selectCustomPricingPlan: { path: '/api/v1/prospects/custom-pricing-plan' },
  confirmEmail: { path: '/api/v1/prospects/${prospectId}/email-confirmation' },
  addCallDetails: { path: '/api/v1/prospects/call-details' },
  createApplication: { path: '/api/v1/prospects/application' },
  findByUserId: { path: '/api/v1/prospects' },
  getUserDetails: { path: '/api/v1/prospects/user-details' },
  getProspectsLegalForms: { path: '/api/v1/prospects/legal-forms' },
}
export const apiPaymentTermController = {
  getPaymentTerm: { path: '/api/v1/payment-terms/${id}' },
  updatePaymentTerm: { path: '/api/v1/payment-terms/${id}' },
  deletePaymentTerm: { path: '/api/v1/payment-terms/${id}' },
  bulkStatusUpdatePaymentTerm: { path: '/api/v1/payment-terms/bulk-status-update' },
  getPaymentTerms: { path: '/api/v1/payment-terms' },
  createPaymentTerm: { path: '/api/v1/payment-terms' },
  getPaymentTermsPaged: { path: '/api/v1/payment-terms/paged' },
  batchUploadPaymentTerms: { path: '/api/v1/payment-terms/batch-upload' },
  batchUploadReviewPaymentTerms: { path: '/api/v1/payment-terms/batch-upload/review' },
}
export const sepaExportDebitorDetailController = {
  updateSepaExportDebitorDetailDefaultFlag: {
    path: '/api/v1/payment-details/accounts-payable/sepa/debitor/${sepaExportDebitorDetailEntry}/default',
  },
  getAllSepaExportDebitorDetails: { path: '/api/v1/payment-details/accounts-payable/sepa/debitor' },
  createSepaExportDebitorDetail: { path: '/api/v1/payment-details/accounts-payable/sepa/debitor' },
  deleteSepaExportDebitorDetail: {
    path: '/api/v1/payment-details/accounts-payable/sepa/debitor/${sepaExportDebitorDetailEntry}',
  },
}
export const organisationProductSwitchIntentController = {
  updateProductSwitchIntent: { path: '/api/v1/organisations/product-switch-intent/${id}' },
  createProductSwitchIntent: { path: '/api/v1/organisations/product-switch-intent' },
  checkEligibility: { path: '/api/v1/organisations/product-switch-intent/${id}/check-eligibility' },
  applyForCredit: { path: '/api/v1/organisations/product-switch-intent/${id}/apply-to-credit' },
}
export const apiOrganisationController = {
  get: { path: '/api/v1/organisation' },
  update: { path: '/api/v1/organisation' },
  updateOrganisationUserRoles: { path: '/api/v1/organisation/users/${userId}/roles' },
  updateSso: { path: '/api/v1/organisation/sso' },
  updateOrganisationUserCostCenter: { path: '/api/v1/organisation/users/${userId}/cost-center' },
  updateOrganisationUserCostCentersBulk: {
    path: '/api/v1/organisation/users/cost-center-bulk-update',
  },
  getAllUserProfilesCsv: { path: '/api/v1/organisation/users/all/csv' },
  downloadUserProfilesCsv: { path: '/api/v1/organisation/users/all/csv' },
  switchOrganisation: { path: '/api/v1/organisation/switch-organisation' },
  applyToCredit: { path: '/api/v1/organisation/apply-to-credit' },
  setHasDismissedSubscriptionActivation: {
    path: '/api/v1/organisation/dismiss-subscription-activation',
  },
  getOrganisationUsers: { path: '/api/v1/organisation/users' },
  getOrganisationUser: { path: '/api/v1/organisation/users/${userId}' },
  removeUserFromOrganisation: { path: '/api/v1/organisation/users/${userId}' },
  getOrganisationUserProfiles: { path: '/api/v1/organisation/users/paged' },
  getAllUserProfiles: { path: '/api/v1/organisation/users/all/paged' },
  getTeamLeadUsers: { path: '/api/v1/organisation/team-lead/users' },
  getStripeCustomerDetails: { path: '/api/v1/organisation/stripe/customer' },
  getOrganisationsOfUser: { path: '/api/v1/organisation/organisations-of-user' },
  getConsents: { path: '/api/v1/organisation/consents' },
  getBankAccounts: { path: '/api/v1/organisation/accounts' },
  removeAdminRoleFromUser: { path: '/api/v1/organisation/users/${userId}/admin' },
}
export const apiVatController = {
  updateVat: { path: '/api/v1/organisation/vat' },
}
export const apiOrganisationBillingController = {
  getBillingAccount: { path: '/api/v1/organisation-billing' },
  updateBilling: { path: '/api/v1/organisation-billing' },
  postUpgradeRequest: { path: '/api/v1/organisation-billing/upgrade-requests' },
  downloadCashBackPdf: { path: '/api/v1/organisation-billing/v2/cashbacks/${id}/pdf' },
  createStripeCheckoutSession: {
    path: '/api/v1/organisation-billing/stripe/customer/checkout-session',
  },
  getPricingPlanVersion: { path: '/api/v1/organisation-billing/pricing-plan-version' },
  getPricingPlanSummary: { path: '/api/v1/organisation-billing/pricing-plan-summary' },
  getCashbacks: { path: '/api/v1/organisation-billing/organisations/cashbacks' },
  getLimitStatus: { path: '/api/v1/organisation-billing/limit-status' },
  downloadPdf: { path: '/api/v1/organisation-billing/invoices/${id}/pdf' },
  getInvoiceSummary: { path: '/api/v1/organisation-billing/invoice-summary' },
  getInvoiceBillingHistory: { path: '/api/v1/organisation-billing/invoice-billing-history' },
  getCurrentPlan: { path: '/api/v1/organisation-billing/current-plan' },
}
export const apiOrganisationAccountingController = {
  getOrganisationAccounting: { path: '/api/v1/organisation-accounting' },
  updateOrganisationAccounting: { path: '/api/v1/organisation-accounting' },
  getPersonaFieldsConfiguration: {
    path: '/api/v1/organisation-accounting/field-configurations/${spendType}/${persona}/fields',
  },
  updateFieldsConfigurationForSpendTypeAndPersona: {
    path: '/api/v1/organisation-accounting/field-configurations/${spendType}/${persona}/fields',
  },
  getFieldsConfiguration: {
    path: '/api/v1/organisation-accounting/field-configurations/${spendType}/fields',
  },
  updateFieldsConfiguration: {
    path: '/api/v1/organisation-accounting/field-configurations/${spendType}/fields',
  },
  updateVatDisabled: {
    path: '/api/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration/vatDisabled',
  },
  updateFileCabinet: {
    path: '/api/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration/fileCabinet',
  },
  getAccountingWalletConfig: {
    path: '/api/v1/organisation-accounting/accounting-configuration/wallets',
  },
  updateAccountingWalletConfig: {
    path: '/api/v1/organisation-accounting/accounting-configuration/wallets',
  },
  createAccountingWalletConfig: {
    path: '/api/v1/organisation-accounting/accounting-configuration/wallets',
  },
  initiateResourceImport: { path: '/api/v1/organisation-accounting/settings/resource/import' },
  searchPlatformObjects: { path: '/api/v1/organisation-accounting/platform-objects/search' },
  preValidate: { path: '/api/v1/organisation-accounting/export/pre-validate' },
  getLastExportStatuses: { path: '/api/v1/organisation-accounting/export/exports/last-status' },
  batchExport: { path: '/api/v1/organisation-accounting/export/batch-exports' },
  createDmsConnection: { path: '/api/v1/organisation-accounting/dms-connection' },
  testDmsConnection: { path: '/api/v1/organisation-accounting/dms-connection/test-connection' },
  createDirectConnectionToPlatform: {
    path: '/api/v1/organisation-accounting/direct-connection/${platformCode}',
  },
  connectToPlatform: { path: '/api/v1/organisation-accounting/connection' },
  getAccountingConfigurationByConnection: {
    path: '/api/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration',
  },
  saveAccountingConfiguration: {
    path: '/api/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration',
  },
  authorize: { path: '/api/v1/organisation-accounting/authorize' },
  getAccountingIntegrationsEnabledFeaturesForOrganisation: {
    path: '/api/v1/organisation-accounting/integrations/features',
  },
  getBatchExportStatus: {
    path: '/api/v1/organisation-accounting/export/batch-exports/${batchExportId}/status',
  },
  getPlatformSyncData: {
    path: '/api/v1/organisation-accounting/connection/${connectionId}/syncInfo',
  },
  getSupplierAccountsByNamePrefix: {
    path: '/api/v1/organisation-accounting/connection/${connectionId}/supplierAccounts',
  },
  getAvailablePlatformOrganisations: {
    path: '/api/v1/organisation-accounting/connection/${connectionId}/platformOrganisations',
  },
  findPlatformDimensionByNamePrefix: {
    path: '/api/v1/organisation-accounting/connection/${connectionId}/platformDimensions',
  },
  getAvailablePlatformDimensions: {
    path: '/api/v1/organisation-accounting/connection/${connectionId}/platform-dimensions/available',
  },
  getFileCabinets: {
    path: '/api/v1/organisation-accounting/connection/${connectionId}/file-cabinets',
  },
  getAccountingYearDetail: {
    path: '/api/v1/organisation-accounting/connection/${connectionId}/accounting-year-detail',
  },
  getConnectionStatus: { path: '/api/v1/organisation-accounting/connection/status' },
  getCurrentDmsConnection: { path: '/api/v1/organisation-accounting/connection/dms-connection' },
  getAllAvailableAccountingPlatforms: {
    path: '/api/v1/organisation-accounting/connection/available-platforms',
  },
  getAllAvailableDmsPlatforms: {
    path: '/api/v1/organisation-accounting/connection/available-dms-platforms',
  },
  getAccountingConfigVisibleFields: {
    path: '/api/v1/organisation-accounting/accounting-configuration/visible-fields',
  },
  disconnect: { path: '/api/v1/organisation-accounting/connection/${connectionId}' },
}
export const apiAdminInviteController = {
  updateInvite: { path: '/api/v1/onboarding/admin-invite/${inviteId}' },
  deleteInvite: { path: '/api/v1/onboarding/admin-invite/${inviteId}' },
  getInvites: { path: '/api/v1/onboarding/admin-invite' },
  createInvite: { path: '/api/v1/onboarding/admin-invite' },
}
export const oldDimensionController = {
  getOldOrganisationDimensionAliases: { path: '/api/v1/old/dimension' },
  updateOldDimensionAlias: { path: '/api/v1/old/dimension' },
  createOldDimensionAlias: { path: '/api/v1/old/dimension' },
  deleteOldDimensionAlias: { path: '/api/v1/old/dimension' },
}
export const apiMissingReceiptPolicyController = {
  getMissingReceiptPolicyById: { path: '/api/v1/missing-receipts-policy/${id}' },
  updateMissingReceiptPolicy: { path: '/api/v1/missing-receipts-policy/${id}' },
  createMissingReceiptPolicy: { path: '/api/v1/missing-receipts-policy' },
  createPolicyPreview: { path: '/api/v1/missing-receipts-policy/preview' },
  getMissingReceiptPoliciesByOrgId: { path: '/api/v1/missing-receipts-policy/organisation' },
  getActiveDefaultMissingReceiptPolicy: {
    path: '/api/v1/missing-receipts-policy/card-types/active',
  },
}
export const apiMerchantDefaultRulesController = {
  updateMerchantDefaultRuleById: { path: '/api/v1/merchant-default-rules/id/${id}' },
  deleteMerchantDefaultRuleById: { path: '/api/v1/merchant-default-rules/id/${id}' },
  getMerchantDefaultRuleByFlowId: { path: '/api/v1/merchant-default-rules/${flowId}' },
  createMerchantDefaultRuleFromFlowId: { path: '/api/v1/merchant-default-rules/${flowId}' },
  deleteMerchantAutoAccountingByFlowId: { path: '/api/v1/merchant-default-rules/${flowId}' },
  getMerchantDefaultRulesPaged: { path: '/api/v1/merchant-default-rules/paged' },
  getMerchantDefaultRulesByOrgId: { path: '/api/v1/merchant-default-rules/list' },
  deleteDefaultVatByFlowId: { path: '/api/v1/merchant-default-rules/${flowId}/vat' },
  deleteDefaultSupplierAccountByFlowId: {
    path: '/api/v1/merchant-default-rules/${flowId}/supplier-account',
  },
  deleteDefaultSubCategoryByFlowId: {
    path: '/api/v1/merchant-default-rules/${flowId}/sub-category',
  },
}
export const apiMerchantDefaultRulesControllerDeprecated = {
  updateMerchantDefaultRuleById: { path: '/api/v1/merchant-category/id/${id}' },
  deleteMerchantDefaultRuleById: { path: '/api/v1/merchant-category/id/${id}' },
  getMerchantDefaultRuleByFlowId: { path: '/api/v1/merchant-category/${flowId}' },
  createMerchantDefaultRuleFromFlowId: { path: '/api/v1/merchant-category/${flowId}' },
  deleteMerchantAutoAccountingByFlowId: { path: '/api/v1/merchant-category/${flowId}' },
  getMerchantDefaultRulesPaged: { path: '/api/v1/merchant-category/paged' },
  getMerchantDefaultRulesByOrgId: { path: '/api/v1/merchant-category/list' },
  deleteDefaultVatByFlowId: { path: '/api/v1/merchant-category/${flowId}/vat' },
  deleteDefaultSupplierAccountByFlowId: {
    path: '/api/v1/merchant-category/${flowId}/supplier-account',
  },
  deleteDefaultSubCategoryByFlowId: { path: '/api/v1/merchant-category/${flowId}/sub-category' },
}
export const apiAuthController = {
  logout: { path: '/api/v1/logout' },
  setPassword: { path: '/api/v1/set-password/${userId}/${token}' },
  triggetResetPassword: { path: '/api/v1/reset-password' },
  loginAndGetRefreshToken: { path: '/api/v1/login' },
  loginWithPinAndGetRefreshToken: { path: '/api/v1/login-with-pin' },
  handleSamlResponse: { path: '/api/v1/handle_saml_response/${organizationId}' },
  getActiveEnrolmentsForUnauthorizedUser: { path: '/api/v1/enrolments' },
  revoke: { path: '/api/v1/enrolments/revoke' },
  makeDefault: { path: '/api/v1/enrolments/make-default' },
  enrol: { path: '/api/v1/enrolments/enrol' },
  activate: { path: '/api/v1/enrolments/activate' },
  checkAccessToken: { path: '/api/v1/check-access-token' },
  getMultiFactorCodeForLogin: { path: '/api/v1/auth_code' },
  exchangeRefreshTokenForAccess: { path: '/api/v1/access_token' },
  handleSamlLogoutRequest: { path: '/api/v1/handle_saml_logout_request/${organizationId}' },
  getSamlRequest: { path: '/api/v1/get_saml_request/${organizationId}' },
  getLoginType: { path: '/api/v1/get_login_type' },
  getActiveEnrolmentsForAuthorizedUser: { path: '/api/v1/enrolments-authenticated' },
}
export const apiInvoicesController = {
  getSubInvoices: { path: '/api/v1/invoices/${invoiceId}/sub-invoices' },
  updateSubInvoices: { path: '/api/v1/invoices/${invoiceId}/sub-invoices' },
  deleteSubInvoices: { path: '/api/v1/invoices/${invoiceId}/sub-invoices' },
  updateInvoiceFieldOption: { path: '/api/v1/invoices/${invoiceId}/invoice-field-options' },
  createInvoiceFieldOption: { path: '/api/v1/invoices/${invoiceId}/invoice-field-options' },
  createOrUpdateDimensionMapping: {
    path: '/api/v1/invoices/${invoiceId}/sub-invoices/${subInvoiceId}/dimension-mapping',
  },
  getInvoicesThumbnails: { path: '/api/v1/invoices/thumbnails' },
  getInvoicesSummary: { path: '/api/v1/invoices/summary' },
  streamDownloadZipInvoices: { path: '/api/v1/invoices/file/batch' },
  downloadInvoicesCustomCsv: { path: '/api/v1/invoices/csv/templates/${templateId}' },
  getInvoiceThumbnail: { path: '/api/v1/invoices/${invoiceId}/thumbnail' },
  downloadInvoiceFile: { path: '/api/v1/invoices/${invoiceId}/file/download' },
  findActivityByInvoiceIdV2: { path: '/api/v1/invoices/${invoiceId}/activity/v2' },
  getInvoiceInboxAccount: { path: '/api/v1/invoices/account' },
  deleteDimensionMapping: {
    path: '/api/v1/invoices/${invoiceId}/sub-invoices/${subInvoiceId}/dimension-mapping/${dimensionId}',
  },
}
export const apiInvoicesCustomisationController = {
  findAllCustomisations: { path: '/api/v1/invoices/customisation' },
  updateInvoiceCustomisation: { path: '/api/v1/invoices/customisation' },
}
export const inAppNotificationController = {
  markInAppNotificationsAsRead: { path: '/api/v1/inapp-notification/markAsRead' },
  findAllInAppNotifications: { path: '/api/v1/inapp-notification' },
  countUnreadInAppNotifications: { path: '/api/v1/inapp-notification/unreadCount' },
}
export const apiExpenseController = {
  updateFileReceiptValidity: { path: '/api/v1/expenses/${expenseId}/file/${fileId}/validity' },
  createExpense: { path: '/api/v1/expenses' },
  uploadExpenseFileWithFlowId: { path: '/api/v1/expenses/flow-id/${flowId}/file' },
  uploadExpenseFilesWithFlowId: { path: '/api/v1/expenses/flow-id/${flowId}/file/batch' },
  uploadExpenseFile: { path: '/api/v1/expenses/file' },
  submitFeedback: { path: '/api/v1/expenses/external-receipts/feedback' },
  checkAvailability: { path: '/api/v1/expenses/external-receipts/account/available' },
  activateReceiptInboxAccount: { path: '/api/v1/expenses/external-receipts/account/activate' },
  getExpenseById: { path: '/api/v1/expenses/${expenseId}' },
  getThumbnailsList: { path: '/api/v1/expenses/${expenseId}/thumbnails' },
  downloadFile: { path: '/api/v1/expenses/${expenseId}/file/${fileId}' },
  deleteFile: { path: '/api/v1/expenses/${expenseId}/file/${fileId}' },
  downloadFileThumbnail: { path: '/api/v1/expenses/${expenseId}/file/${fileId}/thumbnail' },
  downloadFileRaw: { path: '/api/v1/expenses/${expenseId}/file/${fileId}/raw' },
  getImageFile: { path: '/api/v1/expenses/${expenseId}/file/${fileId}/image' },
  getExpenseByCardTransactionId: { path: '/api/v1/expenses/flow-id/${flowId}' },
  getExternalReceiptAccount: { path: '/api/v1/expenses/external-receipts/account' },
  getRecommendedReceiptInboxAccountName: {
    path: '/api/v1/expenses/external-receipts/account/unactivated',
  },
}
export const apiExpenseSplitController = {
  bulkUpdateSplitExpenseVat: { path: '/api/v1/expense/${expenseId}/splits/vat' },
  bulkUpdateSplitExpenseExpenseAccount: {
    path: '/api/v1/expense/${expenseId}/splits/expense-account',
  },
  bulkUpdateSplitExpenseDimensionMapping: {
    path: '/api/v1/expense/${expenseId}/splits/dimension-mapping/${dimensionId}',
  },
  bulkUpdateSplitExpenseCostCenter: { path: '/api/v1/expense/${expenseId}/splits/cost-center' },
  bulkUpdateSplitExpenseCostCarrier: { path: '/api/v1/expense/${expenseId}/splits/cost-carrier' },
  bulkUpdateSplitExpenseBookingText: { path: '/api/v1/expense/${expenseId}/splits/booking-text' },
  bulkUpdateSplitExpenseAmountFields: { path: '/api/v1/expense/${expenseId}/splits/amount-fields' },
  bulkCreateSplitExpense: { path: '/api/v1/expense/${expenseId}/splits' },
  createInitialSplitExpense: { path: '/api/v1/expense/${expenseId}/splits/initial' },
  bulkDeleteSplitExpenses: { path: '/api/v1/expense/${expenseId}/splits/bulk-delete' },
}
export const expensesController = {
  updateExpenseSelectedColumns: { path: '/api/v1/expense/${expenseId}/selected-columns' },
  requestSplitAsync: { path: '/api/v1/expense/${expenseId}/split-automation/request-split' },
  getSummary: { path: '/api/v1/expense/summary' },
  getList: { path: '/api/v1/expense/list' },
  getIds: { path: '/api/v1/expense/ids' },
  bulkUpdateExpenses: { path: '/api/v1/expense/bulk-update' },
  getAllowedActions: { path: '/api/v1/expense/allowed-actions' },
  getCount: { path: '/api/v1/expense/${expenseType}/count' },
  getStatus: { path: '/api/v1/expense/${expenseId}/split-automation/split-status/${requestId}' },
}
export const dimensionController = {
  getAccountingPlatformDimensions: { path: '/api/v1/dimension' },
  updateDimension: { path: '/api/v1/dimension' },
  createDimension: { path: '/api/v1/dimension' },
  batchDeleteDimension: { path: '/api/v1/dimension' },
  createOrUpdateSubTransactionDimensionMapping: {
    path: '/api/v1/dimension/transactions/${flowId}/sub-transactions/${subTransactionId}/mapping',
  },
  createOrUpdateTransactionDimensionMapping: {
    path: '/api/v1/dimension/transactions/${flowId}/mapping',
  },
  deleteSubTransactionDimensionMapping: {
    path: '/api/v1/dimension/transactions/${flowId}/sub-transactions/${subTransactionId}/mapping/${dimensionId}',
  },
  deleteTransactionDimensionMapping: {
    path: '/api/v1/dimension/transactions/${flowId}/mapping/${dimensionId}',
  },
}
export const dimensionItemController = {
  getDimensionItems: { path: '/api/v1/dimension/${dimensionId}/item' },
  batchUpdateDimensionItems: { path: '/api/v1/dimension/${dimensionId}/item' },
  createDimensionItem: { path: '/api/v1/dimension/${dimensionId}/item' },
  batchDeleteDimensionItems: { path: '/api/v1/dimension/${dimensionId}/item' },
  updateDimensionItem: { path: '/api/v1/dimension/${dimensionId}/item/${dimensionItemId}' },
  updateDimensionItemsStatuses: { path: '/api/v1/dimension/${dimensionId}/item/status' },
  updateDimensionItemsManagers: { path: '/api/v1/dimension/${dimensionId}/item/managers' },
  getDimensionItemsByFilters: { path: '/api/v1/dimension/${dimensionId}/item/filter' },
  batchUpload: { path: '/api/v1/dimension/${dimensionId}/item/batch-upload' },
  batchUploadReview: { path: '/api/v1/dimension/${dimensionId}/item/batch-upload/review' },
}
export const apiDepartmentsController = {
  getDepartmentById: { path: '/api/v1/departments/${id}' },
  updateDepartment: { path: '/api/v1/departments/${id}' },
  deleteDepartment: { path: '/api/v1/departments/${id}' },
  createDepartment: { path: '/api/v1/departments' },
  getDepartmentPaged: { path: '/api/v1/departments/paged' },
  getDepartmentsForCurrentOrg: { path: '/api/v1/departments/org' },
}
export const apiDemoController = {
  questionAnswered: { path: '/api/v1/demos/${demoId}/questions/${questionId}' },
  create: { path: '/api/v1/demos' },
  booked: { path: '/api/v1/demos/${demoId}/booked' },
  getById: { path: '/api/v1/demos/${demoId}' },
  getDemoQuestions: { path: '/api/v1/demos/${demoId}/questions' },
}
export const deferredCostLineItemController = {
  update: { path: '/api/v1/deferred-costs/line-items' },
  getSummary: { path: '/api/v1/deferred-costs/line-items/summary' },
  selectAllLineItems: { path: '/api/v1/deferred-costs/line-items/select-all' },
  searchLineItems: { path: '/api/v1/deferred-costs/line-items/search' },
  previewReleasePlan: { path: '/api/v1/deferred-costs/line-items/preview' },
  downloadLineItemCsv: {
    path: '/api/v1/deferred-costs/line-items/csv-configurations/${templateId}/download',
  },
  searchExportErrors: { path: '/api/v1/deferred-costs/line-items/${lineItemId}/export-errors' },
}
export const deferredCostConfigController = {
  get: { path: '/api/v1/deferred-costs-config/${itemId}' },
  update: { path: '/api/v1/deferred-costs-config/${itemId}' },
  create: { path: '/api/v1/deferred-costs-config/${itemId}' },
  delete: { path: '/api/v1/deferred-costs-config/${itemId}' },
}
export const apiPaymentCustomisationsController = {
  getCustomisations: { path: '/api/v1/customisations/accounts-payable' },
  updateCustomisation: { path: '/api/v1/customisations/accounts-payable' },
  requestDisableFourEye: {
    path: '/api/v1/customisations/accounts-payable/request-disable-four-eye',
  },
  rejectFourEyeDisableRequest: {
    path: '/api/v1/customisations/accounts-payable/reject-disable-four-eye-request',
  },
  confirmFourEyeDisableRequest: {
    path: '/api/v1/customisations/accounts-payable/confirm-disable-four-eye-request',
  },
  cancelFourEyeDisableRequest: {
    path: '/api/v1/customisations/accounts-payable/cancel-disable-four-eye-request',
  },
}
export const apiCustomerNotificationSettingsController = {
  findAllNotificationSettings: { path: '/api/v1/customer-notification-settings' },
  updateNotificationSetting: { path: '/api/v1/customer-notification-settings' },
  getNotificationChannelConfiguration: {
    path: '/api/v1/customer-notification-settings/channel-configuration',
  },
}
export const apiCsvExportController = {
  updateCsvConfiguration: { path: '/api/v1/csv-export/configurations/${id}' },
  deleteCsvConfiguration: { path: '/api/v1/csv-export/configurations/${id}' },
  exportCsv: { path: '/api/v1/csv-export/export' },
  searchCsvConfigurations: { path: '/api/v1/csv-export/configurations' },
  createCsvConfiguration: { path: '/api/v1/csv-export/configurations' },
  searchCsvConfigurationSources: {
    path: '/api/v1/csv-export/configurations/${configurationId}/sources',
  },
  downloadAccountingAttribute: { path: '/api/v1/csv-export/accounting-attributes/csv-download' },
  searchCsvTemplates: { path: '/api/v1/csv-export/templates' },
  findCsvTemplateById: { path: '/api/v1/csv-export/templates/${templateId}' },
  searchCsvConfigurationOptions: { path: '/api/v1/csv-export/options' },
  findCsvConfigurationById: { path: '/api/v1/csv-export/configurations/${configurationId}' },
}
export const apiBudgetController = {
  updateBudgetGroup: { path: '/api/v1/budgets' },
  findBudgetByIdAndOrganisationId: { path: '/api/v1/budgets/${budgetId}' },
  updateBudgetPeriod: { path: '/api/v1/budgets/${budgetId}' },
  deleteBudgetByIdAndOrganisationId: { path: '/api/v1/budgets/${budgetId}' },
  assignToBudget: { path: '/api/v1/budgets/${budgetId}/assignments' },
  unassignFromBudgetV2: { path: '/api/v1/budgets/${budgetId}/assignments' },
  pagedBudgetAssignments: { path: '/api/v1/budgets/${budgetId}/assignments/paged' },
  exportAssignmentsCsv: { path: '/api/v1/budgets/${budgetId}/assignments/export/csv' },
  prepareBudgetPeriods: { path: '/api/v1/budgets/prepare-periods' },
  pagedBudget: { path: '/api/v1/budgets/paged' },
  getPurchaseRequestBudgetsMatchWithSpendBudgets: { path: '/api/v1/budgets/matches' },
  findBudgetGroupByIdAndOrganisationId: { path: '/api/v1/budgets/${budgetId}/group' },
  getAllRecommendedBudgets: { path: '/api/v1/budgets/recommended-to' },
  getAllBudgetsAssignedTo: { path: '/api/v1/budgets/assignedTo' },
}
export const apiBankAccountDetailsController = {
  updateBankAccountDetails: { path: '/api/v1/bank-account-details/${id}' },
  deleteBankAccountDetails: { path: '/api/v1/bank-account-details/${id}' },
  getBankAccountDetailsByRelatedAccountTypeAndRelatedAccountId: {
    path: '/api/v1/bank-account-details',
  },
  createBankAccountDetails: { path: '/api/v1/bank-account-details' },
  isRecipientValidForPayment: {
    path: '/api/v1/bank-account-details/${recipientId}/valid-for-payment',
  },
  getPaymentSchemaByParameters: { path: '/api/v1/bank-account-details/schema' },
  getRecipients: { path: '/api/v1/bank-account-details/list' },
  findByWithSchema: { path: '/api/v1/bank-account-details/find-by-with-schema' },
}
export const apiApplicationController = {
  getApplication: { path: '/api/v1/application' },
  updateApplication: { path: '/api/v1/application' },
  updateOrganisationLoan: { path: '/api/v1/application/organisation-loans/${organisationLoanId}' },
  deleteOrganisationLoan: { path: '/api/v1/application/organisation-loans/${organisationLoanId}' },
  updateOrganisationDetails: { path: '/api/v1/application/organisation-details' },
  updateOrganisationShippingAddress: {
    path: '/api/v1/application/organisation-details/shipping-address',
  },
  deleteOrganisationShippingAddress: {
    path: '/api/v1/application/organisation-details/shipping-address',
  },
  updateOrganisationAddress: { path: '/api/v1/application/organisation-details/address' },
  updateManagingDirector: { path: '/api/v1/application/managing-directors/${managingDirectorId}' },
  deleteManagingDirector: { path: '/api/v1/application/managing-directors/${managingDirectorId}' },
  updateManagingDirectorAddress: {
    path: '/api/v1/application/managing-directors/${managingDirectorId}/address',
  },
  updateFileDescriptor: { path: '/api/v1/application/file-descriptors/${descriptorId}' },
  deleteFileDescriptor: { path: '/api/v1/application/file-descriptors/${descriptorId}' },
  updateBeneficialOwner: { path: '/api/v1/application/beneficial-owners/${beneficialOwnerId}' },
  deleteBeneficialOwner: { path: '/api/v1/application/beneficial-owners/${beneficialOwnerId}' },
  updateBeneficialOwnerAddress: {
    path: '/api/v1/application/beneficial-owners/${beneficialOwnerId}/address',
  },
  updateAdminInvite: { path: '/api/v1/application/admin-invites/${adminInviteId}' },
  deleteAdminInvite: { path: '/api/v1/application/admin-invites/${adminInviteId}' },
  signUpForApplication: { path: '/api/v1/application/sign-up' },
  createResetPinRequest: { path: '/api/v1/application/reset-pin-request' },
  confirmResetPinRequest: { path: '/api/v1/application/reset-pin-confirm' },
  getOrganisationLoans: { path: '/api/v1/application/organisation-loans' },
  createOrganisationLoan: { path: '/api/v1/application/organisation-loans' },
  createManagingDirector: { path: '/api/v1/application/managing-directors' },
  getVerificationStatus: {
    path: '/api/v1/application/managing-directors/${managingDirectorId}/verification',
  },
  initiateVerification: {
    path: '/api/v1/application/managing-directors/${managingDirectorId}/verification',
  },
  startVerification: {
    path: '/api/v1/application/managing-directors/${managingDirectorId}/verification/start',
  },
  retryVerification: {
    path: '/api/v1/application/managing-directors/${managingDirectorId}/verification/retry',
  },
  verifyManagingDirectorAddresses: {
    path: '/api/v1/application/managing-directors/verify-address',
  },
  uploadInformationRequestDocument: {
    path: '/api/v1/application/information-requests/${requestId}/document',
  },
  deleteInformationRequestDocument: {
    path: '/api/v1/application/information-requests/${requestId}/document',
  },
  submitInformationRequestResponses: { path: '/api/v1/application/information-requests/submit' },
  uploadApplicationFile: { path: '/api/v1/application/file-data' },
  createBeneficialOwner: { path: '/api/v1/application/beneficial-owners' },
  createAdminInvite: { path: '/api/v1/application/admin-invites' },
  updateInformationRequestValue: { path: '/api/v1/application/information-requests/${requestId}' },
  validateApplication: { path: '/api/v1/application/validate' },
  getSalesforceModules: { path: '/api/v1/application/salesforce-modules' },
  findLocation: { path: '/api/v1/application/location/${placeId}' },
  searchLocation: { path: '/api/v1/application/location/search' },
  getLegalForms: { path: '/api/v1/application/legal-forms' },
  getInformationRequests: { path: '/api/v1/application/information-requests' },
  getFileDescriptors: { path: '/api/v1/application/file-descriptors' },
  downloadApplicationFile: { path: '/api/v1/application/file-data/${descriptorId}' },
  externalValidateApplication: { path: '/api/v1/application/external-validate' },
  getExternalInformationRequests: { path: '/api/v1/application/external-information-requests' },
  getBankAccounts: { path: '/api/v1/application/accounts' },
  getAccountConnections: { path: '/api/v1/application/account-connections' },
  deleteBillingAccount: { path: '/api/v1/application/billing-account' },
}
export const apiActivityController = {
  updateTransactionVat: { path: '/api/v1/activities/${flowId}/vat' },
  updateTransactionSupplierAccount: { path: '/api/v1/activities/${flowId}/supplier-account' },
  updateTransactionNote: { path: '/api/v1/activities/${flowId}/note' },
  updateTransactionInvoiceNumber: { path: '/api/v1/activities/${flowId}/invoice-number' },
  findTransactionExportStatus: { path: '/api/v1/activities/${flowId}/export-status' },
  updateTransactionExportStatus: { path: '/api/v1/activities/${flowId}/export-status' },
  updateTransactionExpenseRequirement: { path: '/api/v1/activities/${flowId}/expense-requirement' },
  updateTransactionCostCenter: { path: '/api/v1/activities/${flowId}/cost-center' },
  updateTransactionCostCarrier: { path: '/api/v1/activities/${flowId}/cost-carrier' },
  getActivitiesForRole: { path: '/api/v1/activities' },
  getUserActivities: { path: '/api/v1/activities/user' },
  getUserActivitiesGrouped: { path: '/api/v1/activities/user/grouped' },
  getUserActivitiesCount: { path: '/api/v1/activities/user/count' },
  getTransactionSummary: { path: '/api/v1/activities/summary' },
  upsertPreAccountingFlow: { path: '/api/v1/activities/pre-accounting-flows' },
  getActivities: { path: '/api/v1/activities/organisation' },
  getOrganisationWalletsActivitiesGrouped: {
    path: '/api/v1/activities/organisation/wallets/grouped',
  },
  organisationWalletPaymentsCsv: { path: '/api/v1/activities/organisation/wallets/download/csv' },
  getOrganisationActivitiesGrouped: { path: '/api/v1/activities/organisation/grouped' },
  getOrganisationActivitiesFlowIdsWithoutPagination: {
    path: '/api/v1/activities/organisation/flow-ids',
  },
  streamExportOrganisationReceiptsGrouped: {
    path: '/api/v1/activities/organisation/export/receipt-batch',
  },
  getOrganisationActivitiesCount: { path: '/api/v1/activities/organisation/count' },
  getActivitiesGrouped: { path: '/api/v1/activities/grouped' },
  getActivitiesFlowIdsWithoutPagination: { path: '/api/v1/activities/flow-ids' },
  streamDownloadReceiptsGrouped: { path: '/api/v1/activities/download/receipt-batch' },
  downloadCsvWithCustomTemplateId: { path: '/api/v1/activities/download/custom/${templateId}' },
  getActivitiesCompressed: { path: '/api/v1/activities/compressed' },
  bulkUpdateTransactions: { path: '/api/v1/activities/bulk-update' },
  getBulkCounts: { path: '/api/v1/activities/bulk-count' },
  downloadBalanceMovementCsvWithCustomTemplateId: {
    path: '/api/v1/activities/balance-movements/download/custom/${templateId}',
  },
  updateCustomerTransactionActivityMerchantCategory: {
    path: '/api/v1/activities/${flowId}/category',
  },
  getActivity: { path: '/api/v1/activities/${flowId}' },
  searchTransactionExportErrors: { path: '/api/v1/activities/${flowId}/export-errors' },
  getExpenseActivityLog: { path: '/api/v1/activities/${flowId}/change-log' },
  balancesByCategory: { path: '/api/v1/activities/spend-by-category' },
  getCardsByOrganisationId: { path: '/api/v1/activities/cards' },
}
export const apiAccountingAutomationController = {
  getConfiguration: { path: '/api/v1/accounting-automation/model/configuration' },
  updateConfiguration: { path: '/api/v1/accounting-automation/model/configuration' },
}
export const deviceV1 = {
  updateCard: { path: '/api/m/spend-request/card' },
  unblockDeviceFromBackoffice: { path: '/api/v1/users/${userId}/device/unblock' },
  deactivateDeviceFromBackoffice: { path: '/api/v1/users/${userId}/device/deactivate' },
  ssoUserActivationRequest: { path: '/api/v1/users/${userId}/device/activation/request/sso' },
  cancelDeviceDeactivateRequestByAdmin: { path: '/api/v1/device/user/${userId}/request-cancel' },
  unlinkDeviceRequestNonSso: { path: '/api/v1/device/unlink' },
  unlinkDeviceRequestConfirmSso: { path: '/api/v1/device/unlink/sso/confirm' },
  unlinkDeviceRequestConfirmNonSso: { path: '/api/v1/device/unlink/confirm' },
  getRefreshTokenForDevice: { path: '/api/v1/device/refresh-token' },
  deactivateDevice: { path: '/api/v1/device/deactivate' },
  setupBiometry: { path: '/api/v1/device/biometry' },
  deleteBiometry: { path: '/api/v1/device/biometry' },
  activateBiometry: { path: '/api/v1/device/biometry/activate' },
  nonSsoUserResendSms: { path: '/api/v1/device/activation/resend-sms/non-sso' },
  activationFinalization: { path: '/api/v1/device/activation/finalize' },
  ssoUserActivationCreate: { path: '/api/v1/device/activation/create/sso' },
  nonSsoUserActivationCreate: { path: '/api/v1/device/activation/create/non-sso' },
  smsOtpActivationConfirmation: { path: '/api/v1/device/activation/confirm/sms' },
  emailOtpActivationConfirmation: { path: '/api/v1/device/activation/confirm/email' },
  getDeviceStatus: { path: '/api/v1/users/${userId}/device' },
  activationProcessStatus: { path: '/api/v1/users/${userId}/device/activation-process-status' },
  getVirtualPanPreviewToken: { path: '/api/m/card/virtual/${cardId}/details-token' },
  deactivateDeviceByAdmin: { path: '/api/v1/device/user/${userId}' },
  unlinkDeviceRequestSso: { path: '/api/v1/device/unlink/sso' },
}
export const mobileApiDigitalWalletsController = {
  approveTokenProvision: {
    path: '/api/m/digital-wallets/card/${cardId}/token/${tokenId}/provision/approval',
  },
  requestTokenProvisionGooglePay: { path: '/api/m/digital-wallets/provision/googlepay' },
  requestTokenProvisionApplePay: { path: '/api/m/digital-wallets/provision/applepay' },
  getTokensForCard: { path: '/api/m/digital-wallets/card/${cardId}/wallet/data' },
  getTokenizableCardsForUser: { path: '/api/m/digital-wallets/card/wallet/data' },
  getDetailsForSplashScreen: { path: '/api/m/digital-wallets/card/splashscreen' },
}
export const mobileApiCardsController = {
  activateVirtualCard: { path: '/api/m/cards/activate/virtual/${cardId}' },
  getCards: { path: '/api/m/cards' },
  getCard: { path: '/api/m/cards/${cardId}' },
  getUserCardsPaged: { path: '/api/m/cards/user/paged' },
  getOrganisationCardsPaged: { path: '/api/m/cards/organisation/paged' },
}
export const mobileAuthorizationController = {
  createAuthorizationRequestForWeb: { path: '/api/web/authorization/request' },
  loginRequestForMobile: { path: '/api/web/authorization/login' },
  createLoginRequestForWeb: { path: '/api/web/authorization/login/auth' },
  findLoginRequestForWebUnauthorizedWithPassword: {
    path: '/api/web/authorization/login/auth/${authId}',
  },
  markLoginAsRejectedFromWeb: { path: '/api/web/authorization/login/auth/${authId}' },
  findAuthorizationRequestForMobile: { path: '/api/m/authorization/request' },
  createAuthorizationRequestForMobile: { path: '/api/m/authorization/request' },
  findAuthorizationRequestForWeb: { path: '/api/web/authorization/request/${authId}' },
  markAuthorizationAsRejectedFromWeb: { path: '/api/web/authorization/request/${authId}' },
  markAuthorizationAsRejectedFromMobile: { path: '/api/m/authorization/request/${authId}' },
}
export const apiAuthV3Controller = {
  loginAndGetRefreshToken: { path: '/api/v3/validate' },
  getActiveEnrolmentsForUnauthorizedUser: { path: '/api/v3/enrolments' },
  revoke2FaEnrolment: { path: '/api/v3/enrolments/revoke' },
  make2FaEnrolmentDefault: { path: '/api/v3/enrolments/make-default' },
  create2FaEnrolment: { path: '/api/v3/enrolments/enrol' },
  create2FaEnrolmentForSSoUser: { path: '/api/v3/enrolments/enrol-for-sso-user' },
  activate2FaEnrolment: { path: '/api/v3/enrolments/activate' },
  getChallenge: { path: '/api/v3/auth_code' },
  getActiveEnrolmentsForAuthorizedUser: { path: '/api/v3/enrolments-authenticated' },
}
export const otpController = {
  validate: { path: '/api/v3/otp/validate' },
  testOtp: { path: '/api/v3/otp/test' },
  challenge: { path: '/api/v3/otp/challenge' },
}
export const apiCardsV2Controller = {
  createBulkCards: { path: '/api/v2/users/bulk-cards' },
  createCard: { path: '/api/v2/user/${userId}/card' },
  getSubscriptionMigrations: { path: '/api/v2/subscription-migrations' },
  createMigration: { path: '/api/v2/subscription-migrations' },
  createSubscriptionMigrationCards: {
    path: '/api/v2/subscription-migrations/${subscriptionMigrationRequestId}/cards',
  },
  createMigrationV2: { path: '/api/v2/subscription-migrations/v2' },
  calculateCardLimitsTotal: { path: '/api/v2/card-limits/organisation/total' },
  getSubscriptionMigrationCardOrders: {
    path: '/api/v2/subscription-migrations/${subscriptionMigrationRequestId}/card-orders',
  },
  getCard: { path: '/api/v2/card/${cardId}' },
}
export const userConsentControllerV2 = {
  reAccept: { path: '/api/v2/terms-and-conditions/re-accept' },
  reAcceptAuthorized: { path: '/api/v2/terms-and-conditions/re-accept/authorized' },
}
export const apiSubscriptionsV2Controller = {
  create: { path: '/api/v2/subscriptions' },
}
export const apiSpendRequestV2Controller = {
  requestCreateCard: { path: '/api/v2/spend-request/card' },
}
export const consentControllerV2 = {
  sendNotificationForEmiLicenceCampaign: {
    path: '/api/v2/organisation/consents/campaign/emi-licence/notify',
  },
  sendNotificationForAwxMigrationCampaign: {
    path: '/api/v2/organisation/consents/campaign/awx-migration/notify',
  },
  findByOrganisationId: { path: '/api/v2/organisation/consents' },
  getAcceptanceSummaryForEmiLicenceCampaign: {
    path: '/api/v2/organisation/consents/campaign/emi-licence',
  },
  getAcceptanceSummaryForAwxMigrationCampaign: {
    path: '/api/v2/organisation/consents/campaign/awx-migration',
  },
  findConsents: { path: '/api/v2/consents' },
  getMissing: { path: '/api/v2/consents/missing' },
  getFunnelSuitable: { path: '/api/v2/consents/funnel-suitable/${country}' },
  findConsentsByIds: { path: '/api/v2/consents/by-ids' },
  findConsentsByApplicationId: { path: '/api/v2/application/consents' },
}
export const mobileAuthorizationV2Controller = {
  findAuthorizationRequestForMobile: { path: '/api/v2/m/authorization/request' },
  createAuthorizationRequestForMobile: { path: '/api/v2/m/authorization/request' },
}
export const apiAuthV2Controller = {
  loginAndGetRefreshToken: { path: '/api/v2/login' },
  getMultiFactorCodeForLogin: { path: '/api/v2/auth_code' },
}
export const apiInvoicesV2Controller = {
  updateDuplicatesV3: { path: '/api/v2/invoices/duplicates/update' },
  checkDuplicateV2: { path: '/api/v2/invoices/duplicate' },
  findAllDuplicatesV2ByInvoiceId: { path: '/api/v2/invoices/duplicates/${invoiceId}' },
}
export const apiInviteV2Controller = {
  createBulkInviteFromFileBackoffice: {
    path: '/api/v2/invite/bulk/csv-file-upload/backoffice/${organisationId}',
  },
  getAll: { path: '/api/v2/invite' },
  verifyInvite: { path: '/api/v2/invite/${organisationId}/${token}/verify' },
}
export const apiDemoControllerV2 = {
  create: { path: '/api/v2/demos' },
  getById: { path: '/api/v2/demos/${demoId}' },
  update: { path: '/api/v2/demos/${demoId}' },
  booked: { path: '/api/v2/demos/${demoId}/booked' },
}
export const apiBudgetControllerV2 = {
  createBudget: { path: '/api/v2/budgets' },
}
export const apiApplicationControllerV2 = {
  createStripeSession: { path: '/api/v2/application/stripe-session' },
  uploadInformationRequestDocument: {
    path: '/api/v2/application/information-requests/${requestId}/document',
  },
  deleteInformationRequestDocument: {
    path: '/api/v2/application/information-requests/${requestId}/document',
  },
  submitInformationRequestResponses: { path: '/api/v2/application/information-requests/submit' },
  updateInformationRequestValue: { path: '/api/v2/application/information-requests/${requestId}' },
  getStripeCustomerDetails: { path: '/api/v2/application/stripe/customer' },
  getInformationRequests: { path: '/api/v2/application/information-requests' },
  getByOrganisationIdAndTypes: { path: '/api/v2/application/by-organisation/with-types' },
  getApplicantByApplicationId: { path: '/api/v2/application/applicant' },
}
export const apiWorkflowController = {
  getSlimTicketsWithoutPagination: { path: '/api/v1/workflow/tickets/slim/all' },
  findAllByUserAndStatus: { path: '/api/v1/workflow/tickets/paged' },
  getTicketExecutorsByReference: { path: '/api/v1/workflow/tickets/executors/fetch' },
  handleRequest: { path: '/api/v1/workflow/request' },
  handleBulkRequest: { path: '/api/v1/workflow/request/bulk' },
  handleRequestWithOtp: { path: '/api/v1/workflow/request/2fa' },
  findAllByUserAndStatusPaged: { path: '/api/v1/workflow/tickets' },
  findById: { path: '/api/v1/workflow/tickets/${id}' },
  countAllPaginated: { path: '/api/v1/workflow/tickets/count' },
}
export const apiWithdrawalController = {
  bookWithdrawal: { path: '/api/v1/withdrawal' },
  prepareWithdrawal: { path: '/api/v1/withdrawal/prepare' },
  executeWithdrawal: { path: '/api/v1/withdrawal/execute' },
}
export const apiWiseController = {
  findById: { path: '/api/v1/wise/connection' },
  connect: { path: '/api/v1/wise/connection' },
  disconnect: { path: '/api/v1/wise/connection' },
}
export const walletTopUpsControllerV1 = {
  prepareTopUpPayment: { path: '/api/v1/wallets/${walletId}/top-ups/open-banking/prepare' },
  executeTopUpPayment: { path: '/api/v1/wallets/${walletId}/top-ups/open-banking/execute' },
  getWalletTopUpInfo: { path: '/api/v1/wallets/${walletId}/top-ups/info' },
}
export const apiStatementControllerV2 = {
  generateCustomStatement: { path: '/api/v1/wallets/${walletId}/statements/generate' },
  get: { path: '/api/v1/wallets/${walletId}/statements' },
  export: { path: '/api/v1/wallets/${walletId}/statements/${id}/export' },
}
export const apiVerificationController = {
  sendIdNowLinkTextByVerificationId: {
    path: '/api/v1/verification/personal/id-now-text-message/${verificationId}',
  },
  get: { path: '/api/v1/verification/identity/${id}' },
  initialiseIfNotInitialised: { path: '/api/v1/verification/identity/${id}' },
  start: { path: '/api/v1/verification/identity/${id}/start' },
  sendSms: { path: '/api/v1/verification/identity/${id}/send-sms' },
  retry: { path: '/api/v1/verification/identity/${id}/retry' },
}
export const apiVendorsController = {
  findAll: { path: '/api/v1/vendors' },
  findByVendorName: { path: '/api/v1/vendors' },
  findById: { path: '/api/v1/vendors/${id}' },
}
export const apiAbsencesController = {
  bulkAbsencesUpdate: { path: '/api/v1/users/${userId}/absences/bulk-update' },
  usersAbsenceSummary: { path: '/api/v1/users/absence-summary' },
  absenceStatistics: { path: '/api/v1/users/absence-stats' },
  getAbsences: { path: '/api/v1/users/${userId}/absences' },
}
export const userOrganisationController = {
  searchUserOrganisation: { path: '/api/v1/users/organisations/search' },
}
export const apiUniversalInboxController = {
  convertInvoiceToReceipt: {
    path: '/api/v1/universal-inbox/invoice/${invoiceDescriptorId}/to-receipt',
  },
  getAllInvoiceDescriptors: { path: '/api/v1/universal-inbox/invoice/paged' },
  bulkDeleteInvoices: { path: '/api/v1/universal-inbox/invoice/bulk-delete' },
  convertReceiptToInvoice: {
    path: '/api/v1/universal-inbox/external-receipts/${externalReceiptId}/to-invoice',
  },
  getExternalReceiptsInboxForUser: { path: '/api/v1/universal-inbox/external-receipts/user/paged' },
  uploadReceiptFiles: { path: '/api/v1/universal-inbox/external-receipts/upload-files' },
  getExternalReceiptsInbox: { path: '/api/v1/universal-inbox/external-receipts/paged' },
  linkExternalReceiptToTransaction: { path: '/api/v1/universal-inbox/external-receipts/link' },
  bulkLinkExternalReceiptToTransaction: {
    path: '/api/v1/universal-inbox/external-receipts/bulk-link',
  },
  streamDownloadOrganisationReceiptsGrouped: {
    path: '/api/v1/universal-inbox/external-receipts/bulk-download',
  },
  bulkDeleteExternalReceipt: { path: '/api/v1/universal-inbox/external-receipts/bulk-delete' },
  downloadExternalReceiptFile: {
    path: '/api/v1/universal-inbox/external-receipts/${externalReceiptId}/file/download',
  },
  getNumberOfUnlinkedReceipts: { path: '/api/v1/universal-inbox/external-receipts/unlinked' },
}
export const organisationTrialsController = {
  getTrials: { path: '/api/v1/trials' },
  requestTrial: { path: '/api/v1/trials' },
}
export const apiTopUpController = {
  getIssuedTopUps: { path: '/api/v1/top-ups' },
  create: { path: '/api/v1/top-ups' },
  getTopUpsByStatus: { path: '/api/v1/top-ups/status/${status}' },
}
export const apiTopUpPaymentController = {
  preparePayment: { path: '/api/v1/top-ups/payments/prepare' },
  executePayment: { path: '/api/v1/top-ups/payments/execute' },
  completePayment: { path: '/api/v1/top-ups/payments/complete' },
  cancelPayment: { path: '/api/v1/top-ups/payments/cancel' },
}
export const apiTopUpFundingSourceController = {
  findAll: { path: '/api/v1/top-ups/funding-sources' },
  create: { path: '/api/v1/top-ups/funding-sources' },
  setDefault: { path: '/api/v1/top-ups/funding-sources/${id}/default' },
  delete: { path: '/api/v1/top-ups/funding-sources/${id}' },
}
export const testController = {
  loginAsTestUser: { path: '/api/v1/test/login-as-e2e-user' },
}
export const apiSubscriptionsController = {
  create: { path: '/api/v1/subscriptions' },
  findAllPaginated: { path: '/api/v1/subscriptions/paged' },
  findPlatformFeeSubscription: { path: '/api/v1/subscriptions/platform-fee' },
}
export const apiSpendPolicyController = {
  save: { path: '/api/v1/spend-policy/request' },
  findAll: { path: '/api/v1/spend-policy' },
  findById: { path: '/api/v1/spend-policy/${id}' },
}
export const txTeamAssignmentController = {
  getAssignedTeam: { path: '/api/v1/spend-approval/tx/team' },
  assignTeam: { path: '/api/v1/spend-approval/tx/team' },
}
export const slackAppController = {
  unlinkUserProfile: { path: '/api/v1/slack/user-profile/unlink' },
  getNotificationSettings: { path: '/api/v1/slack/notification-settings' },
  updateNotificationSettings: { path: '/api/v1/slack/notification-settings' },
  setNotificationChannel: { path: '/api/v1/slack/notification-channel' },
  processEvent: { path: '/api/v1/slack/events' },
  unlinkAccount: { path: '/api/v1/slack/account/unlink' },
  checkUserProfile: { path: '/api/v1/slack/user-profile' },
  handleCallback: { path: '/api/v1/slack/oauth/callback' },
  installSlackApp: { path: '/api/v1/slack/install' },
  getAllChannels: { path: '/api/v1/slack/channels' },
  checkAccount: { path: '/api/v1/slack/account' },
}
export const openSignUpController = {
  signUp: { path: '/api/v1/sign-up' },
}
export const selfSignUpApiController = {
  createLeadWithPersonalDetails: { path: '/api/v1/self-signup/leads/personal-details' },
  createUserWithOrganisation: { path: '/api/v1/self-signup/creation' },
  getOrCreateApplication: { path: '/api/v1/self-signup/application' },
  updateLeadProductDetailsByOrganisationId: {
    path: '/api/v1/self-signup/leads/product-details/${organisationId}',
  },
  updateLeadFunnelStatusByUserId: {
    path: '/api/v1/self-signup/leads/funnel-status/userId/${userId}',
  },
  getLegalFormsForSelfSignUp: { path: '/api/v1/self-signup/legal-forms' },
  getLegalFormsDescribedForSelfSignUp: { path: '/api/v1/self-signup/legal-forms-desc' },
  getLeadFunnelStatusByOrganisationId: {
    path: '/api/v1/self-signup/leads/funnel-status/organisationId/${organisationId}',
  },
  getLeadFunnelStatusWithFlowVersionByOrganisationId: {
    path: '/api/v1/self-signup/leads/funnel-status-versioned/organisationId/${organisationId}',
  },
  getAllowedPhoneCountryCodes: { path: '/api/v1/self-signup/allowed-phone-country-codes' },
}
export const apiMileageRateController = {
  createOrUpdateMileageRates: { path: '/api/v1/reimbursement/rates/mileage' },
  getMileageRateList: { path: '/api/v1/reimbursement/rates/mileage/list' },
  getMileageRate: { path: '/api/v1/reimbursement/rates/mileage/${id}' },
  getMileageRateSnapshot: { path: '/api/v1/reimbursement/rates/mileage/${id}/v/${version}' },
  areLegalRatesConfigured: {
    path: '/api/v1/reimbursement/rates/mileage/check-legal-rates-configuration',
  },
}
export const apiPurchaseOrderFileController = {
  createPurchaseOrderFile: { path: '/api/v1/purchase-requests/purchase-order/file' },
}
export const apiPurchaseRequestsNumberConfigurationController = {
  getCurrentPoNumberConfiguration: { path: '/api/v1/purchase-requests/configuration/poNumber' },
  updateCurrentPoNumberConfiguration: { path: '/api/v1/purchase-requests/configuration/poNumber' },
  getPoNumberConfigurationHistory: {
    path: '/api/v1/purchase-requests/configuration/poNumberHistory',
  },
}
export const paymentActivationController = {
  notifyLegalReps: { path: '/api/v1/payments/activation/notify-legal-reps' },
  getPaymentsActivationModalDetails: { path: '/api/v1/payments/activation/modal-details' },
}
export const accountsPayablePaymentController = {
  listByIds: { path: '/api/v1/payments/accounts-payable/list/ids' },
  execute: { path: '/api/v1/payments/accounts-payable/execute/batch' },
  editPaymentReference: { path: '/api/v1/payments/accounts-payable/edit/payment-reference' },
  getLatestByFlowTypeAndId: {
    path: '/api/v1/payments/accounts-payable/linkedFlow/${flowType}/${flowId}/latest',
  },
  getAllByBatchId: { path: '/api/v1/payments/accounts-payable/by-batch/${batchId}' },
}
export const apiPaymentDetailsController = {
  downloadAccountsPayableCustomCsv: { path: '/api/v1/payment-details/csv/templates/${templateId}' },
  getSummary: { path: '/api/v1/payment-details/accounts-payable/summary' },
  getAccountsPayableSepaPaymentPreviewSummary: {
    path: '/api/v1/payment-details/accounts-payable/sepa/preview',
  },
  downloadAccountsPayableSepaFile: {
    path: '/api/v1/payment-details/accounts-payable/sepa/download',
  },
  revokeFirstAuthorization: {
    path: '/api/v1/payment-details/accounts-payable/revoke-first-authorization',
  },
  preparePayment: { path: '/api/v1/payment-details/accounts-payable/prepare/payment' },
  downloadPaymentOrderConfirmation: {
    path: '/api/v1/payment-details/accounts-payable/payment-order-confirmation',
  },
  getPaymentExecutionDetails: {
    path: '/api/v1/payment-details/accounts-payable/payment-execution-details',
  },
  getPaged: { path: '/api/v1/payment-details/accounts-payable/paged' },
  markAsPaid: { path: '/api/v1/payment-details/accounts-payable/mark-as-paid' },
  markAsNotPaid: { path: '/api/v1/payment-details/accounts-payable/mark-as-not-paid' },
  getCount: { path: '/api/v1/payment-details/accounts-payable/count' },
  authorize: { path: '/api/v1/payment-details/accounts-payable/authorise' },
  getAll: { path: '/api/v1/payment-details/accounts-payable/all' },
  editPaymentReference: {
    path: '/api/v1/payment-details/accounts-payable/${id}/edit-payment-reference',
  },
  getById: { path: '/api/v1/payment-details/accounts-payable/${id}' },
  getListByLinkedFlows: { path: '/api/v1/payment-details/accounts-payable/list/by-linked-flow' },
  getListByIds: { path: '/api/v1/payment-details/accounts-payable/list/by-ids' },
  getInProgressAccountsPayableDetails: {
    path: '/api/v1/payment-details/accounts-payable/in-progress-accounts-payable-details',
  },
  getByLinkedFlow: { path: '/api/v1/payment-details/accounts-payable/by-linked-flow' },
}
export const apiPasswordStrengthController = {
  checkPasswordStrength: { path: '/api/v1/password-strength' },
}
export const userActivityController = {
  getUser: { path: '/api/v1/organisation/${organisationId}/user/${userId}/activity' },
  createActivity: { path: '/api/v1/organisation/${organisationId}/user/${userId}/activity' },
  getUserActivityById: {
    path: '/api/v1/organisation/${organisationId}/user/${userId}/activity/${activityName}',
  },
  userActivityExistsById: {
    path: '/api/v1/organisation/${organisationId}/user/${userId}/activity/${activityName}/exists',
  },
  getActivitiesForOrg: { path: '/api/v1/organisation/${organisationId}/activity' },
}
export const apiOrganisationSettingsController = {
  getUserViewPreferences: { path: '/api/v1/organisation-settings/user-preferences' },
  getSupplierViewPreferences: { path: '/api/v1/organisation-settings/supplier-preferences' },
  importCsvPlatformDetailsFromOtherEntity: {
    path: '/api/v1/organisation-settings/csv-templates/other-entity/${otherEntityId}/import',
  },
  createOrUpdateCsvPlatformDetails: { path: '/api/v1/organisation-settings/csv-platform-details' },
  getViewPreferences: { path: '/api/v1/organisation-settings/view-preferences' },
  getOrganisationSettings: { path: '/api/v1/organisation-settings/internal-settings' },
  getOtherEntityCsvConfigurations: {
    path: '/api/v1/organisation-settings/csv-platform-details/other-entity/${otherEntityId}/csv-configurations-list',
  },
  getActiveCsvPlatformDetailsForOrganisation: {
    path: '/api/v1/organisation-settings/csv-platform-details/active',
  },
  getAvailableCsvExportFormats: {
    path: '/api/v1/organisation-settings/csv-export-formats/available-formats',
  },
  deleteActiveCsvPlatformDetailsForOrganisation: {
    path: '/api/v1/organisation-settings/csv-platform-details/delete',
  },
}
export const openBankingController = {
  prepareFinapiCreditTransfer: { path: '/api/v1/open-banking/provider/finapi/payments' },
  submitFinapiCreditTransfer: { path: '/api/v1/open-banking/provider/finapi/payments/submit' },
  initiateConnection: { path: '/api/v1/open-banking/connections/initiate' },
  completeConnection: { path: '/api/v1/open-banking/connections/complete' },
  updateAccountActiveFlag: { path: '/api/v1/open-banking/bank-accounts/${accountId}/active' },
  getFinApiWebForm: { path: '/api/v1/open-banking/providers/finapi/${webFormId}' },
  findOpenBankingPayment: { path: '/api/v1/open-banking/provider/finapi/payments/${paymentId}' },
  getInstitutions: { path: '/api/v1/open-banking/institutions' },
  getAccountConnections: { path: '/api/v1/open-banking/connections' },
  deleteAccount: { path: '/api/v1/open-banking/providers/${providerType}/bank-accounts/${id}' },
}
export const apiNotificationTrackingEventsController = {
  publishTrackingEvents: { path: '/api/v1/notification-tracking-events/mobile' },
}
export const myTasksController = {
  getMyTasks: { path: '/api/v1/my-tasks' },
  getTaskSummary: { path: '/api/v1/my-tasks/summary' },
}
export const apiMultiEntityController = {
  createMultiEntityApplication: { path: '/api/v1/multientity/applications' },
  findById: { path: '/api/v1/multientity/organisations/${id}' },
}
export const apiModuleController = {
  requestDemo: { path: '/api/v1/modules/${apiModuleCode}/demo' },
  activate: { path: '/api/v1/modules/${apiModuleCode}/activate' },
  isCardsOnly: { path: '/api/v1/modules/is-cards-only' },
  getOrganisationModules: { path: '/api/v1/modules' },
}
export const apiMobileRegistrationTokenController = {
  save: { path: '/api/v1/mobile-registration-token' },
  delete: { path: '/api/v1/mobile-registration-token/${registrationToken}' },
}
export const apiMissingReceiptsController = {
  notifyAboutMissingReceipts: { path: '/api/v1/missing-receipts/notify' },
  getMissingReceiptsGroupedByUser: { path: '/api/v1/missing-receipts/grouped-by-user' },
  getMissingReceiptsGroupedByUserWithFilterRequest: {
    path: '/api/v1/missing-receipts/grouped-by-user',
  },
}
export const missingInformationController = {
  notifyAboutMissingInformation: { path: '/api/v1/missing-information/notify' },
  getMissingInformationGroupedByUser: { path: '/api/v1/missing-information/grouped-by-user' },
}
export const apiLocationController = {
  signStaticMapUrl: { path: '/api/v1/location/sign-static-map-url' },
  searchByPlaceId: { path: '/api/v1/location/${placeId}' },
  search: { path: '/api/v1/location/search' },
}
export const leadController = {
  create: { path: '/api/v1/lead' },
  waitlist: { path: '/api/v1/lead/${leadId}/waitlist' },
  selfSignup: { path: '/api/v1/lead/${leadId}/self-signup' },
  createDemo: { path: '/api/v1/lead/${leadId}/demo' },
  book: { path: '/api/v1/lead/${leadId}/demo/booked' },
  update: { path: '/api/v1/lead/${leadId}/funnel-step/${currentFunnelStep}' },
  getFunnelValues: { path: '/api/v1/lead/${leadId}/funnel-values' },
}
export const apiLandingPageController = {
  addToEarlyAccessList: { path: '/api/v1/landing/get-early-access' },
}
export const apiKomboController = {
  getActiveIntegrationByOrganisationId: { path: '/api/v1/kombo/integration' },
  connectIntegration: { path: '/api/v1/kombo/integration' },
  deactivateIntegration: { path: '/api/v1/kombo/integration' },
  getTeamMappings: { path: '/api/v1/kombo/integration/team-mappings' },
  addTeamMappings: { path: '/api/v1/kombo/integration/team-mappings' },
  getMatchedEmployees: { path: '/api/v1/kombo/integration/employees/matched' },
  linkMatchedEmployees: { path: '/api/v1/kombo/integration/employees/matched' },
  inviteEmployees: { path: '/api/v1/kombo/integration/employees/invite' },
  getLinkedInfoPaged: { path: '/api/v1/kombo/integration/employee/linked-info/paged' },
  resolveAllConflicts: {
    path: '/api/v1/kombo/integration/employee/linked-info/conflicts/resolve-all',
  },
  getAbsenceTypes: { path: '/api/v1/kombo/integration/absence-types' },
  saveAbsenceTypes: { path: '/api/v1/kombo/integration/absence-types' },
  getKomboTeams: { path: '/api/v1/kombo/integration/teams' },
  getActiveEmployees: { path: '/api/v1/kombo/integration/employees/paged' },
  getActiveEmployeesFiltered: { path: '/api/v1/kombo/integration/employees/filtered' },
  getConflictsCount: { path: '/api/v1/kombo/integration/employee/linked-info/conflicts-count' },
  createKomboConnectFlowLink: { path: '/api/v1/kombo/connect-flow-link' },
}
export const apiInviteController = {
  resendInvitation: { path: '/api/v1/invite/${organisationId}/user/${userId}/resend' },
  signUpFromInvite: { path: '/api/v1/invite/sign-up' },
  createBulkInvite: { path: '/api/v1/invite/bulk' },
  createBulkInviteFromFile: { path: '/api/v1/invite/bulk/csv-file-upload' },
  createBulkInviteFromFileBackoffice: {
    path: '/api/v1/invite/bulk/csv-file-upload/backoffice/${organisationId}',
  },
  bulkInviteAccountants: { path: '/api/v1/invite/bulk/accountants' },
  findEmailProvider: { path: '/api/v1/invite/email-provider' },
  findCandidates: { path: '/api/v1/invite/candidates' },
}
export const apiMagicInviteController = {
  getMagicInvites: { path: '/api/v1/invite/magic-link' },
  createMagicInviteAndGetSecret: { path: '/api/v1/invite/magic-link' },
  createAndInviteUser: { path: '/api/v1/invite/magic-link/invite' },
  getInviteeInfoByMagicInviteId: { path: '/api/v1/invite/magic-link/${magicInviteId}/invitee' },
}
export const apiGrowthLeadsController = {
  provideBenchmarkResultForRequest: { path: '/api/v1/growth-leads/saas-benchmark/find-result' },
  getAvailableMetricsCombinations: {
    path: '/api/v1/growth-leads/saas-benchmark/metrics-combinations',
  },
}
export const apiFileMatchRequestController = {
  createMatchRequest: { path: '/api/v1/fileMatchRequest' },
}
export const fameController = {
  uploadFile: { path: '/api/v1/fame/files' },
  getPagedFiles: { path: '/api/v1/fame/files/paged' },
  findFileById: { path: '/api/v1/fame/files/${id}' },
  deleteFile: { path: '/api/v1/fame/files/${id}' },
  downloadFile: { path: '/api/v1/fame/files/${id}/file' },
  getFileStatus: { path: '/api/v1/fame/files/${id}/fileStatus' },
  findFilesByResourceIdAndResourceType: {
    path: '/api/v1/fame/files/files-by-resourceId-and-resourceType',
  },
}
export const apiDatevExportController = {
  getDatevStatus: { path: '/api/v1/export/datev' },
  createExport: { path: '/api/v1/export/datev' },
  revokeDatevTokens: { path: '/api/v1/export/datev/revoke' },
  completeDatevConnection: { path: '/api/v1/export/datev/connection' },
  setClientId: { path: '/api/v1/export/datev/clients/${clientId}' },
  getExportStatus: { path: '/api/v1/export/datev/${exportId}/status' },
  downloadExportZip: { path: '/api/v1/export/datev/${exportId}/files' },
}
export const eInvoiceController = {
  findByFlowIds: { path: '/api/v1/einvoice/expense/flow-id/list' },
  getPreviewData: { path: '/api/v1/einvoice/${flowType}/resource/${resourceId}/preview' },
}
export const dunaApplicationController = {
  initiateOnboardingAndReturnToken: { path: '/api/v1/duna/application' },
}
export const apiMsController = {
  cloneExistingCredentials: { path: '/api/v1/document-fetcher/ms/clone' },
  processAuthorizationCode: { path: '/api/v1/document-fetcher/ms/oauth2code' },
  getAuthorizationCodeRequestUrl: {
    path: '/api/v1/document-fetcher/ms/authorizationCodeRequestUrl',
  },
}
export const apiMetaController = {
  cloneExistingCredentials: { path: '/api/v1/document-fetcher/meta/clone' },
  processAuthorizationCode: { path: '/api/v1/document-fetcher/meta/oauth2code' },
  getAuthorizationCodeRequestUrl: {
    path: '/api/v1/document-fetcher/meta/authorizationCodeRequestUrl',
  },
}
export const merchantSupportStatusController = {
  getSupported: { path: '/api/v1/document-fetcher/merchants/supported' },
}
export const apiGoogleAdsController = {
  cloneExistingCredentials: { path: '/api/v1/document-fetcher/google-ads/clone' },
  processAuthorizationCode: { path: '/api/v1/document-fetcher/google-ads/oauth2code' },
  getAuthorizationCodeRequestUrl: {
    path: '/api/v1/document-fetcher/google-ads/authorizationCodeRequestUrl',
  },
}
export const apiGmailController = {
  cloneExistingCredentials: { path: '/api/v1/document-fetcher/gmail/clone' },
  processAuthorizationCode: { path: '/api/v1/document-fetcher/gmail/oauth2code' },
  getAuthorizationCodeRequestUrl: {
    path: '/api/v1/document-fetcher/gmail/authorizationCodeRequestUrl',
  },
}
export const apiDataInsightsController = {
  orderedBarChartWidget: { path: '/api/v1/data-insights/widgets/ordered-bar-chart' },
  lineChartWidget: { path: '/api/v1/data-insights/widgets/line-chart' },
  donutChartWidget: { path: '/api/v1/data-insights/widgets/donut-chart' },
  getOpenBankingTransactionsPost: { path: '/api/v1/data-insights/transactions/paged' },
  startImport: { path: '/api/v1/data-insights/transactions/import' },
  idsForFilter: { path: '/api/v1/data-insights/transactions/ids' },
  getDuplicatesByOrganisationAndId: {
    path: '/api/v1/data-insights/transactions/duplicates/handle',
  },
  deleteTransactions: { path: '/api/v1/data-insights/transactions/delete' },
  openBankingTransactionsCsvPost: { path: '/api/v1/data-insights/transactions/csv' },
  bulkUpdate: { path: '/api/v1/data-insights/transactions/bulk-update' },
  bulkUpdateExtended: { path: '/api/v1/data-insights/transactions/bulk-update-extended' },
  updateSelectedAccounts: {
    path: '/api/v1/data-insights/organisation-user-settings/selectedAccounts',
  },
  updateMossBalanceEnabled: {
    path: '/api/v1/data-insights/organisation-user-settings/mossBalanceEnabled',
  },
  updateCurrency: { path: '/api/v1/data-insights/organisation-user-settings/currency' },
  getByOrganisationAndId: { path: '/api/v1/data-insights/transactions/${id}' },
  getDuplicatesById: { path: '/api/v1/data-insights/transactions/${id}/duplicates' },
  getCsvImportTemplate: { path: '/api/v1/data-insights/transactions/import/csv-template' },
  getCashflowHistoryReport: { path: '/api/v1/data-insights/reports/cashflow-history' },
  getBalanceHistoryReport: { path: '/api/v1/data-insights/reports/balance-history' },
  getAvailableBalanceReport: { path: '/api/v1/data-insights/reports/available-balance' },
  getAvailableOverviewAccounts: { path: '/api/v1/data-insights/reports/available-accounts' },
  findOrganisationUserSettings: { path: '/api/v1/data-insights/organisation-user-settings' },
  getAvailableAccounts: { path: '/api/v1/data-insights/cash-flows/available-accounts' },
  deleteTransactionsByIdAndLinkId: {
    path: '/api/v1/data-insights/transactions/${trxId}/links/${linkId}/delete',
  },
}
export const organisationCustomisationController = {
  getByOrganisationId: { path: '/api/v1/customisation' },
  createCustomisation: { path: '/api/v1/customisation' },
  update: { path: '/api/v1/customisation' },
}
export const apiCostCenterController = {
  createCostCenter: { path: '/api/v1/cost-center' },
  getById: { path: '/api/v1/cost-center/${costCenterId}' },
  updateCostCenter: { path: '/api/v1/cost-center/${costCenterId}' },
  deleteCostCenter: { path: '/api/v1/cost-center/${costCenterId}' },
  updateManagers: { path: '/api/v1/cost-center/managers' },
  bulkUpdateCostCenters: { path: '/api/v1/cost-center/bulk-update' },
  batchUploadCostCenters: { path: '/api/v1/cost-center/batch-upload' },
  batchUploadReviewSuppliers: { path: '/api/v1/cost-center/batch-upload/review' },
  getByIds: { path: '/api/v1/cost-center/${costCenterIds}' },
  getAllPagedByOrganisation: { path: '/api/v1/cost-center/paged' },
  getAllByOrganisation: { path: '/api/v1/cost-center/organisation' },
  getCostCentersIdsByOrganisationWithoutPagination: {
    path: '/api/v1/cost-center/organisation/all/ids',
  },
}
export const apiCostCarrierController = {
  createCostCarrier: { path: '/api/v1/cost-carrier' },
  getById: { path: '/api/v1/cost-carrier/${costCarrierId}' },
  updateCostCarrier: { path: '/api/v1/cost-carrier/${costCarrierId}' },
  deleteCostCarrier: { path: '/api/v1/cost-carrier/${costCarrierId}' },
  updateManagers: { path: '/api/v1/cost-carrier/managers' },
  bulkUpdateCostCarriers: { path: '/api/v1/cost-carrier/bulk-update' },
  batchUploadCostCarriers: { path: '/api/v1/cost-carrier/batch-upload' },
  batchUploadReviewCostCarriers: { path: '/api/v1/cost-carrier/batch-upload/review' },
  getByIds: { path: '/api/v1/cost-carrier/${costCarrierIds}' },
  getAllPagedByOrganisation: { path: '/api/v1/cost-carrier/paged' },
  getAllByOrganisation: { path: '/api/v1/cost-carrier/organisation' },
  getCostCarriersIdsByOrganisationWithoutPagination: {
    path: '/api/v1/cost-carrier/organisation/all/ids',
  },
}
export const conversationsController = {
  getConversationMessages: { path: '/api/v1/copilot/conversations/${conversationId}/messages' },
  postMessage: { path: '/api/v1/copilot/conversations/${conversationId}/messages' },
  postFeedback: {
    path: '/api/v1/copilot/conversations/${conversationId}/messages/${messageId}/feedback',
  },
  startConversation: { path: '/api/v1/copilot/conversations/new/messages' },
  getConversations: { path: '/api/v1/copilot/conversations' },
  downloadMessageRawTableCvs: {
    path: '/api/v1/copilot/conversations/${conversationId}/messages/${messageId}/raw-data/csv',
  },
  getMessagePivotTable: {
    path: '/api/v1/copilot/conversations/${conversationId}/messages/${messageId}/pivot-table',
  },
}
export const commentsController = {
  attach: { path: '/api/v1/comments/${commentId}/attach' },
  postRequest: { path: '/api/v1/comments/request' },
  findAllByFlowTypeAndFlowId: { path: '/api/v1/comments/list' },
  findUsersDraftByTypeAndFlowId: { path: '/api/v1/comments/draft' },
  deleteAttachment: { path: '/api/v1/comments/${commentId}/attach/${attachmentId}' },
}
export const cardTransactionExpenseController = {
  searchCardTransactionExpensesOld: { path: '/api/v1/card-transaction-expenses' },
  getSummary: { path: '/api/v1/card-transaction-expenses/summary' },
  searchCardTransactionExpenses: { path: '/api/v1/card-transaction-expenses/search' },
  searchCardTransactionExpenseIds: { path: '/api/v1/card-transaction-expenses/search-ids' },
  bulkUpdate: { path: '/api/v1/card-transaction-expenses/bulk-update' },
  getCardTransactionExpense: { path: '/api/v1/card-transaction-expenses/${expenseId}' },
}
export const apiAttachmentController = {
  upload: { path: '/api/v1/attachments' },
  checkDuplicate: { path: '/api/v1/attachments/duplicate' },
  findByFileId: { path: '/api/v1/attachments/${id}' },
  delete: { path: '/api/v1/attachments/${id}' },
  download: { path: '/api/v1/attachments/${id}/download' },
  getAttachedFiles: {
    path: '/api/v1/attachments/referenceType/${referenceType}/referenceId/${referenceId}',
  },
  findByReferenceIdAndReferenceType: { path: '/api/v1/attachments/list' },
}
export const apiApprovalConfigurationController = {
  resolveConfiguration: { path: '/api/v1/approval-configuration/request' },
}
export const apiAccountingSetupController = {
  notifyAccountants: { path: '/api/v1/accounting-setup/notify-accountant' },
}
export const apiAccountingPlatformDemoController = {
  getUpsellingInfo: { path: '/api/v1/accounting-integration/platform/upsell' },
  upsell: { path: '/api/v1/accounting-integration/platform/upsell' },
  registerToPlatform: { path: '/api/v1/accounting-integration/platform/registration' },
  getDemoRedirectUrl: { path: '/api/v1/accounting-integration/platform/connection-url' },
}
export const firmController = {
  createClient: { path: '/api/v1/accounting-firms/clients' },
  searchClient: { path: '/api/v1/accounting-firms/clients/search' },
}
export const apiActivityV2Controller = {
  patchActivities: { path: '/api/v2/activities' },
}
export const docsController = {
  apiDocs: { path: '/${service}/v3/api-docs/**' },
}
export const walletController = {
  getActiveAvailableWallets: { path: '/api/v1/wallets' },
  getActiveWalletById: { path: '/api/v1/wallets/${walletId}' },
  getWalletCollectionType: { path: '/api/v1/wallets/${walletId}/collection-type' },
  getAllWallets: { path: '/api/v1/wallets/all' },
}
export const walletSpendController = {
  getDebitSpendInProgressDeprecated: { path: '/api/v1/wallets/${walletId}/spend/in-progress' },
  getDebitSpendInProgress: { path: '/api/v1/wallets/${walletId}/spend/in-progress/debit' },
  getSpendInProgressDebit2Fa: { path: '/api/v1/wallets/${walletId}/spend/in-progress/debit/2fa' },
  getCreditSpendInProgress: { path: '/api/v1/wallets/${walletId}/spend/in-progress/credit' },
  getSpendInProgressCredit2Fa: { path: '/api/v1/wallets/${walletId}/spend/in-progress/credit/2fa' },
  getSpendInProgress2Fa: { path: '/api/v1/wallets/${walletId}/spend/in-progress/2fa' },
  getCurrentPeriodSpend: { path: '/api/v1/wallets/${walletId}/spend/current-period' },
  getCurrentPeriodSpend2Fa: { path: '/api/v1/wallets/${walletId}/spend/current-period/2fa' },
}
export const invoicesController = {
  findInvoices: { path: '/api/v1/wallets/${walletId}/credit-invoices' },
  export: { path: '/api/v1/wallets/${walletId}/credit-invoices/${id}/export' },
}
export const beneficiaryBankAccountControllerV2 = {
  getWalletVerifiedSourceAccountsForCurrentOrganisationId: {
    path: '/api/v1/wallets/${walletId}/bank-accounts/verified-source-accounts',
  },
  getWalletBeneficiaryBankAccountForCurrentOrganisation: {
    path: '/api/v1/wallets/${walletId}/bank-accounts/beneficiary',
  },
}
export const apiStatementController = {
  get: { path: '/api/v1/statements' },
  downloadPdf: { path: '/api/v1/statements/${statementId}/pdf' },
  getEventsByStatementId: { path: '/api/v1/statements/${statementId}/events' },
  downloadCsv: { path: '/api/v1/statements/${statementId}/csv' },
  warnings: { path: '/api/v1/statements/warnings' },
}
export const apiMileageItinerariesController = {
  findLastItineraries: { path: '/api/v1/reimbursement/mileage/itineraries' },
}
export const apiRateController = {
  getRate: { path: '/api/v1/rate' },
}
export const apiRateCbpr2Controller = {
  get: { path: '/api/v1/rate-cbpr2' },
}
export const permissionController = {
  getPermissionsPayments: { path: '/api/v1/permissions/payments' },
  getPermissionsPaymentsForWallet: { path: '/api/v1/permissions/payments/wallets/${walletId}' },
}
export const apiPerksProviders = {
  get: { path: '/api/v1/perks/providers' },
}
export const paymentWalletController = {
  getEligibleWallets: { path: '/api/v1/payments/wallets' },
  getPaymentWalletDetails: { path: '/api/v1/payments/wallets/${walletId}/details' },
}
export const apiPaymentChannelController = {
  getOrganisationPaymentChannels: { path: '/api/v1/payments/channels' },
}
export const organisationApplicationController = {
  findApplications: { path: '/api/v1/organisation/applications' },
}
export const apiOnboardingController = {
  get: { path: '/api/v1/onboarding' },
}
export const apiCurrentUserApplicationsController = {
  getCurrentUserActiveApplicationPreviews: { path: '/api/v1/me/applications/active/preview' },
}
export const apiIbanValidationController = {
  getBicForIban: { path: '/api/v1/iban/${iban}/bic' },
}
export const apiTravelPerkController = {
  processAuthorizationCode: { path: '/api/v1/document-fetcher/travelperk/oauth2code' },
  getAuthorizationCodeRequestUrl: {
    path: '/api/v1/document-fetcher/travelperk/authorizationCodeRequestUrl',
  },
}
export const integrationManagementController = {
  status: { path: '/api/v1/document-fetcher/common/status' },
  disconnect: { path: '/api/v1/document-fetcher/common/${integrationName}' },
}
export const euDebitMigrationController = {
  isOrganisationMigrated: { path: '/api/v1/deutsche-bank-migration/${organisationId}/migrated' },
}
export const apiCurrencyConversionController = {
  calculate: { path: '/api/v1/currency-conversion' },
}
export const apiCurrencyController = {
  list: { path: '/api/v1/currencies' },
}
export const copilotSettingsController = {
  getSettings: { path: '/api/v1/copilot/settings' },
}
export const promptController = {
  getPrompts: { path: '/api/v1/copilot/prompts' },
}
export const apiCelloController = {
  token: { path: '/api/v1/cello/token' },
}
export const categoryController = {
  getOrganisationCategories: { path: '/api/v1/categories' },
}
export const beneficiaryBankAccountController = {
  getVerifiedSourceAccountsAccountForCurrentOrganisation: {
    path: '/api/v1/bank-accounts/verified-source-accounts',
  },
  getBeneficiaryBankAccountForCurrentOrganisation: { path: '/api/v1/bank-accounts/beneficiary' },
}
export const apiBalanceController = {
  getMonthlySpendHistoryForUser: { path: '/api/v1/balance/spend-history/user/monthly' },
  getMonthlySpendHistory: { path: '/api/v1/balance/spend-history/monthly' },
  getDailySpendHistory: { path: '/api/v1/balance/spend-history/daily' },
  findCreditBalanceDeprecated: { path: '/api/v1/balance/organisation' },
  findCreditBalanceByOrgIdDeprecated: { path: '/api/v1/balance/organisation/${id}' },
  findDebitBalance: { path: '/api/v1/balance/organisation/debit' },
  findDebitBalanceByOrgId: { path: '/api/v1/balance/organisation/debit/${id}' },
  findCreditBalance: { path: '/api/v1/balance/organisation/credit' },
  findCreditBalanceByOrgId: { path: '/api/v1/balance/organisation/credit/${id}' },
  findLimits: { path: '/api/v1/balance/limits' },
  getMonthlyCardSpendHistory: { path: '/api/v1/balance/card-spend-history/monthly' },
  findBooking: { path: '/api/v1/balance/booking' },
}
export const awxMigrationController = {
  getAirwallexUkMigrationStatus: { path: '/api/v1/airwallex-uk-migration' },
}
export const activationController = {
  getChecklist: { path: '/api/v1/activation/checklist' },
}
export const mobileApprovalsController = {
  getMobileTicketByTicketId: { path: '/api/m/workflow/ticket/${ticketId}' },
  getMobileOutgoingRequestByTicketId: { path: '/api/m/workflow/request/${ticketId}' },
}
export const mobileTasksController = {
  getMobileTasks: { path: '/api/m/mobile-tasks' },
}
export const mobileApiActivityController = {
  getActivity: { path: '/api/m/activities/detail/${flowId}' },
}
